var bPopupActive = false;
var bSuggestClicked = false;
var bToggleClearSearchFieldClicked = false;
var bMenuLoaded = false;

var typingTimer;
var doneTypingInterval = 300;

function el(elementId) {
	return document.getElementById(elementId);
}

Object.defineProperty(window,'el',{
	value : function(elementId) {
				return document.getElementById(elementId);
			},
	writable: false
});

(function($) {
	$.fn.onClassChange = function(cb) {
		return $(this).each((_, el) => {
		  new MutationObserver(mutations => {
			mutations.forEach(mutation => cb && cb(mutation.target, mutation.target.className));
		  }).observe(el, {
			attributes: true,
			attributeFilter: ['class']
		  });
		});
	  }
})(jQuery);

function askNotCountsTowardsTotal(sAction, sProductId)
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'allowNotCountsTowardsTotal', {'action': sAction, 'productId': sProductId});
	setPopupHeader(oPopup, sAllowNotCountsTowardsTotalTitle, '');
	oPopup.find('.modal-body .content').html(sAllowNotCountsTowardsTotalInfo);

	oPopup.find('.modal-footer .action').html(sYes);
	oPopup.find('.modal-footer .cancel').html(sNo);

	oPopup.modal();
}

function createQrCode()
{
	// create qr code
	uAjax = "/index.cfm/ajax/createqrcode";
	var sParams = '&url=' + window.location.href;
	var oCall = callAjax("createqrcode", sParams, "POST");

	// process result
	oCall.success(function (oData)
	{
		if (typeof oData.qrCodeUrl !== "undefined" && oData.qrCodeUrl !== "" && typeof QRCode !== "undefined")
		{
			new QRCode(document.getElementById("createQrCodeResult"), {
				text: oData.qrCodeUrl,
				width: 1000,
				height: 1000
			});

			setTimeout(function()
			{
				var aUrl = window.location.href.split("/");
				var sFileName = aUrl[aUrl.length - 1].replace(/[\W_]+/g,"-");
				var sSrc = $("#createQrCodeResult img").attr("src");
				var oAnchor = document.createElement("a");
				oAnchor.href = sSrc;
				oAnchor.download = "qrcode-" + sFileName + ".png";
				oAnchor.click();

				$(el("createQrCodeForPage")).prop("disabled",false);
			}, 1500);
		}
		else
		{
			$(el("createQrCodeForPage")).prop("disabled",false);
		}
	});
}

function handleTriggerJsHeaderSearch(oEl)
{
	oEl.parents('.jsHeaderSearchWrapper').addClass('jsHeaderSearchActive');
	oEl.parents('.jsHeaderSearchWrapper').find('.jsHeaderSearchSubmitWrapper').show();
	oEl.siblings('.dismissJsHeaderSearch').show();
	$('html, body').animate({ scrollTop: 0 }, 0);
	$('html, body').css({'overflow':'hidden', 'position': 'relative', 'height':'100%'});
}

function handleDismissJsHeaderSearch(oEl)
{
	oEl.parents('.jsHeaderSearchWrapper').removeClass('jsHeaderSearchActive');
	oEl.parents('.jsHeaderSearchWrapper').find('.jsHeaderSearchSubmitWrapper').hide();
	oEl.hide();
	$('html, body').css({'overflow':'visible', 'position': 'static', 'height':'auto'});
	$(el('suggest')).remove();
}

// jquery methods
(function($) {
	$.fn.ajaxLoader = function(sAction) {
		// create and show the loader
		if (sAction === 'show') {
			//check if loader is not already existing
			var isLoaderExisting = $('#ajaxLoaderImgId').length;
			//if not existing, create the loader
			if(isLoaderExisting === 0){
				var oLoader = $('<img src="/styles/images/icon/ajax-loader.gif" class="hide ajaxLoader" id="ajaxLoaderImgId" />');
				this.after(oLoader);
				oLoader.fadeIn(200);
			}
		}

		// hide and destroy the loader
		if (sAction === 'hide') {
			this.next('.ajaxLoader').fadeOut(200, function() {
				$(this).remove();
			});
		}

		return this;
	}
}(jQuery));

var loadMobileNavigation = function () {
	// Get navigation from cache
	uAjax = "/index.cfm/ajax/mobilenavigation";
	var oCall = callAjax("mobilenavigation", "", "get");
	// process result
	oCall.success(function (oData) {
		bMenuLoaded = true;
		if (oData.html !== "")
		{
			if($(".nav-collapse .fsMenuInner").length > 0)
			{
				$(".nav-collapse .fsMenuInner").html(oData.html);
			}
			else
			{
				$(".nav-collapse.fsMenu").html(oData.html);
			}
		}
	});
};

var doneTyping = function (input, e) {
	var iKeyCode = e.keyCode;
	var sKeyword = input.val();

	if (sKeyword !== '') {
		suggestKeyHandler(input, iKeyCode, sKeyword);
	}
	else {
		$(el('suggest')).remove();
	}
}

var popupSendPicturePack = function(sSkuIds,oButton){
	$('#sendConfirmPicturePackModal').modal('show')
	$('#sendConfirmPicturePackModal #btnSend').data('skuIds',sSkuIds);
}

var initLazyResponsiveLoad = function () {
	// IE fallback
	var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		setTimeout(function(){
			$(".ci-image").css("opacity",100);
		}, 1000);
	}
}

function addProductToBasket(oBtn, iQty)
{
	var sProductId = oBtn.closest('li').data('product');
	var sParams = '&productid=' + sProductId + '&bMobile=' + ($(window).width() < 768);
	oBtn.attr('disabled','disabled');

	//Normal thumb add to basket
	if (oBtn.closest('li').hasClass('thumb')) {
		var selectedSizeSkuId = oBtn.closest('.thumb').find('.selectedSkuId').attr('data-skuId');
		if (typeof selectedSizeSkuId !== 'undefined') {
			sParams += '&selectedSizeSkuId=' + selectedSizeSkuId;
		} else if(typeof oBtn.attr('data-firstSkuId') !== "undefined" && oBtn.attr('data-firstSkuId') !== -1) {
			sParams += '&selectedSizeSkuId=' + oBtn.attr('data-firstSkuId');
		}
	}

	// Shop the look thumb add to basket
	if (oBtn.closest('li').hasClass('shopthelookthumb')) {
		var selectedSizeSkuId = oBtn.closest('.shopthelookthumb').find('.selectedSkuId').attr('data-skuId');
		var oSelectedThumb = $(".shopthelookthumb[data-product='" +  sProductId + "']");
		var hideSizeWrapper = oSelectedThumb.find(".sizeWrapper").hasClass("hide");

		// has sizes, size selected - add to basket
		if (typeof selectedSizeSkuId !== 'undefined') {
			oBtn.attr('disabled','disabled');
			sParams += '&selectedSizeSkuId=' + selectedSizeSkuId;
		}
		// has sizes, no size selected - show error
		else if (!hideSizeWrapper) {
			oBtn.removeAttr('disabled');
			oSelectedThumb.find('.dropdown-toggle .sizeTitle').css('color','red');
			return;
		}
		// no sizes (one size product) - use first SKU if available
		else if (hideSizeWrapper){
			var firstSkuId = oSelectedThumb.find('.selectedSkuId').attr('data-firstSkuId');
			if (typeof firstSkuId !== 'undefined' && firstSkuId !== '' && firstSkuId !== '-1' && firstSkuId !== -1) {
				sParams += '&selectedSizeSkuId=' + firstSkuId;
			}
		}
	}

	if (typeof iQty !== 'undefined') sParams += '&qty=' + iQty;
	uAjax = "/index.cfm/product/ajax/addproduct";
	var oCall = callAjax("products", sParams, "post");

	// process result
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			if(typeof oData.price !== 'undefined' && typeof oData.qty !== 'undefined' && typeof oData.skuId !== 'undefined')
			{
				// Get product image from thumb
				var productImage = '';
				var thumbImage = oBtn.closest('li.thumb, li.shopthelookthumb').find('.productImage');
				if (thumbImage.length > 0) {
					productImage = thumbImage.attr('src') || thumbImage.attr('data-src') || '';
				}

				$(document).trigger("fbqAddToCartThumb",[oData.skuId,oData.qty,oData.price]);
				$(document).trigger("addProductToBasket",[oData.skuId]);
				$(document).trigger("ga4AddProductToBasket",[oData.skuId,oData.qty,oData.price,productImage]); // consumed by GA4 and TW eventTag (fires regardless of GA4 setting)
			}

			if(typeof oData.addskupopup !== "undefined" && $('#addSkuPopup').length > 0)
			{
				// trigger modal with upsell products
				$('#addSkuPopup').html(oData.addskupopup);
				$('#addSkuPopup .modal').modal('show');
				centerPopups();

				// update basketdropdown but don't show
				$('#basketDropdown').html(oData.html);
			}
			else
			{
				showBasketDropdown(oData.html);
				if (!$('#basketSidebar').length >= 1) {
					$('html, body').animate({scrollTop: '0px'}, 300);
				}
			}

			if (window.history && window.history.pushState)
			{
				window.history.pushState({"addedProductToBasket": true}, "addedProductToBasket", location.href);
			}

			oBtn.removeAttr('disabled');
		}
		else {
			// For shopthelookthumb, don't redirect on error
			if (!oBtn.closest('li').hasClass('shopthelookthumb')) {
				// check for href
				if(oBtn.attr('href') !== "undefined" && oBtn.attr('href') !== "")
				{
					window.location = oBtn.attr('href');
				}
				else
				{
					// could not add to basket, go to product detail
					window.location = '/product/detail/' + sProductId;
				}
			}
			else {
				oBtn.removeAttr('disabled');
			}
		}
	});
}

function addToWishlist(sProductId)
{
	uAjax = "/index.cfm/customer/ajax/addtowishlist";

	var sParams = '&productId=' + sProductId;
	var oCall = callAjax("addToWishlist", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '')
		{
			$(document).trigger( "addToWishlist", sProductId); // also consumed by GA4 and TW eventTag

			if($('.wishlistContainer').length > 0)
			{
				$('.wishlistContainer').replaceWith(oData.html);

				ciResponsive.process();
			}
			if($('.wishlistQuantity').length > 0)
			{
				$('.wishlistQuantity').html('<span>'+oData.wishlistQuantity+'</span>');
				if(oData.wishlistQuantity == 0)
				{
					$('.wishlistQuantity').hide();
				}
				else
				{
					$('.wishlistQuantity').show();
					$('.wishlistQuantity span').css('animation','pulse 2s 3');
				}
			}
			var oThumb = $('.thumb[data-product="' + sProductId + '"]');
			oThumb.find('.fa-heart-o').addClass('fa-heart').removeClass('fa-heart-o');
			oThumb.find('.icon-heart-empty').addClass('icon-heart').removeClass('icon-heart-empty');
			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function addToWishlistList(oBtn, bAskNotCountsTowardsTotal)
{
	oBtn.prop('disabled', true);

	var oSelectedOption = $('#addProductWishlistPopup').find('#wishlistsDropdown option:selected');
	var sWishlistId = oSelectedOption.val();
	var sTypeId = oSelectedOption.data('type-id');
	var sSkuId = $('#addProductWishlistPopup').find('.sProductSkuId').val();
	var bRememberWishlist = $('#addProductWishlistPopup .rememberWishlist').is(":checked");
	var oThumb = $('.thumb[data-product="' + $('#addProductWishlistPopup').find('.sProductId').val() + '"]');
	var bAskNotCountsTowardsTotal = (bAskNotCountsTowardsTotal === false) ? false : true;

	uAjax = "/index.cfm/wishlist/ajax/addSku";
	var sParams = '&skuid=' + sSkuId + '&id=' + sWishlistId + '&rememberwishlist=' + bRememberWishlist + '&typeId=' + sTypeId + '&askNotCountsTowardsTotal=' + bAskNotCountsTowardsTotal;

	var oCall = callAjax("addSku", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '')
		{
			$('#addProductWishlistPopup .modal').modal('hide');
			$('#popupContinue').modal('hide');

			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
			oThumb.find('.fa-heart-o').addClass('fa-heart').removeClass('fa-heart-o');
			sWishlistProducts = sWishlistProducts + "," + sSkuId;
			$(document).trigger('wishlistSkuChanged', [String(sSkuId), true]);

			addSkuActions( sWishlistId, sSkuId, bRememberWishlist);
		}
		else if (oData.errorType == 'product_not_allowed') {
			$('#addProductWishlistPopup').find('.wishlistProductAddError').show();
		}
		else if(oData.errorType == 'notCountsTowardsTotal') {
			askNotCountsTowardsTotal("addToWishlistList");
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}

		oBtn.prop('disabled', false);
	});
}

// A product thumb has to resolve the selected size before it knows its sku, but a caller that already
// knows it (a basket line, which is one concrete sku) can say so on the element itself. Explicit wins,
// otherwise the thumb lookup is exactly as it was.
function resolveWishlistSkuId(oEl, oThumb)
{
	var sSkuId = oEl.data('skuid');

	if (typeof sSkuId !== 'undefined' && sSkuId !== '') return String(sSkuId);

	sSkuId = oThumb.find('.selectedSkuId').attr('data-skuId');

	return (typeof sSkuId === 'undefined') ? oEl.closest('.thumb').find('.selectedSkuId').attr('data-firstSkuId') : sSkuId;
}

function addToWishlistPopup(oEl, sProductId, bAskNotCountsTowardsTotal)
{
	var oThumb = $('.thumb[data-product="' + sProductId + '"]');
	var selectedSizeSkuId = resolveWishlistSkuId(oEl, oThumb);
	var bAskNotCountsTowardsTotal = (bAskNotCountsTowardsTotal === false) ? false : true;
	var sParams = '&skuid=' + selectedSizeSkuId + '&askNotCountsTowardsTotal=' + bAskNotCountsTowardsTotal;
	uAjax = "/index.cfm/wishlist/ajax/addToWishlistPopup";

	var oCall = callAjax("addToWishlistPopup", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '' || (typeof oData.errorCode !== "undefined" && oData.errorCode == '401'))
		{
			var oWishlistModal = oData.html;
			$('#addProductWishlistPopup').html(oWishlistModal);
			var elProductId = $('<input>', {
				type: 'hidden',
				class: 'sProductId',
				name: 'sProductId',
				value: sProductId
			});
			$('#addProductWishlistPopup .addProductWishlistModal').append(elProductId);
			$('#addProductWishlistPopup .modal').modal('show');
			centerPopups();
		} else if (oData.errorType == 'product_added') {
			$('#popupContinue').modal('hide');
			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
			oThumb.find('.fa-heart-o').addClass('fa-heart').removeClass('fa-heart-o');

			sWishlistProducts = sWishlistProducts + "," + selectedSizeSkuId;
			$(document).trigger('wishlistSkuChanged', [String(selectedSizeSkuId), true]);

			addSkuActions(oData.wishlistId, selectedSizeSkuId, false);
		}
		else if (oData.errorType == 'not_logged_in') {
			window.location = '/' + sCurrentLanguageCode + '/customer/login'
		}
		else if (oData.errorType == 'product_not_allowed') {
			var oWishlistModal = oData.html;
			$('#addProductWishlistPopup').html(oWishlistModal);
			$('#addProductWishlistPopup').find('.wishlistProductAddError').show();
			$('#addProductWishlistPopup .modal').modal('show');
			centerPopups();
		}
		else if(oData.errorType == 'no_skuid' || oData.errorType == 'cannotAdd') {
			// could not add to wishlist, go to product detail
			window.location = '/product/detail/' + sProductId;
		}
		else if(oData.errorType == 'notCountsTowardsTotal') {
			askNotCountsTowardsTotal("addToWishlistPopup", sProductId);
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		oEl.prop('disabled',false);
	});
}

function addSkuActions(sWishlistId, sSkuId, bRememberWishlist)
{
	var sParams = '&skuid=' + sSkuId + '&id=' + sWishlistId + '&rememberwishlist=' + bRememberWishlist;
	var oCall = callAjax("addSkuActions", sParams, "post", "/index.cfm/wishlist/ajax/addSkuActions");
	oCall.success(function(oData)
	{
		if (oData.errorType == "")
		{
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			$("#mainContainer header").append(oData.productAddedDropdown);
			$("#mainContainer header .wishlistProductDropdown").css('animation','pulse 2s 3');
			$("#mainContainer header .wishlistProductDropdown").hide().fadeIn(500).delay(5000).fadeOut(500, function(){
				$(this).remove();
			});
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function changeContentPage(page) {
	var sParams = '&page=' + page;
	var oCall = callAjax("getpages", sParams, "post", "/index.cfm/content/ajax/getpages");
	// process feedback
	oCall.success(function(oData) {
		if (oData.errorType == '') {
			$(el('changeContentPage')).find('.modal-body').html(oData.html);
			$(el('changeContentPage')).modal();

			centerPopups();
		} else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function closeCookiePopup(button)
{
	setCookie('hideCookieBanner','true',30);
	button.closest('.cookies').slideToggle(400);
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function isTouchDevice() {
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	var mq = function(query) {
		return window.matchMedia(query).matches;
	}

	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		return true;
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

function setLinkedPage(block, page, button) {
	// show loader
	var oLoader = button;
	oLoader.ajaxLoader('show');
	$('.btnPick').hide();
	var sParams = '&block=' + block + '&page=' + page;
	var oCall = callAjax("setlinkedpage", sParams, "post", "/index.cfm/content/ajax/setlinkedpage");
	// process feedback
	oCall.success(function(oData) {
		if (typeof oData.id !== 'undefined' || oData.errorMessage === '') {
			location.reload();
		} else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			$('.btnPick').show();
			oLoader.ajaxLoader('hide');
		}
	});
}

function processAjax(action, sParams, sMethod, sContainerId) {
	var oCall = callAjax(action, sParams, sMethod);
	oCall.success(function(oData) {
		if (oData.errorType == '' && oData.html != '') {
			refreshContent(sContainerId, oData.html);
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function refreshContent(sContainerId, oHtml) {
	$('.modal').modal('hide');
	bPopupActive = false;
	$('#' + sContainerId).html(oHtml);
	$('.scroll-pane').jScrollPane({
		mouseWheelSpeed: 40,
		verticalDragMinHeight: 30
	});
}

function callAjax(action, sParams, sMethod, url, bAsyncSpecified) {

	if (typeof url === 'undefined') {
		url = uAjax;
	}

	if(typeof bAsyncSpecified === 'undefined')
	{
		bAsyncSpecified = true;
	}

	// return ajax call reference
	if (typeof sParams === 'object') {
		// with json
		return $.ajax({
			url: url + "?action=" + action,
			data: JSON.stringify(sParams),
			dataType: 'json',
			contentType: "application/json; charset=utf-8",
			type: sMethod,
			async: bAsyncSpecified,
			cache: false
		});
	} else {
		// params are a query string
		return $.ajax({
			url: url,
			data: "action=" + action + sParams,
			dataType: 'json',
			type: sMethod,
			async: bAsyncSpecified,
			cache: false
		});
	}
}

function buildConfigurator(type,code,sku,order,orderLine,readonly)
{
	if(type != '' && code !== '' && sku !== '')
	{
		var sParams = '&type=' + type + '&code=' + code + '&skuId=' + sku + '&orderLineId=' + encodeURIComponent(orderLine) + '&orderId=' + order + '&readonly=' + readonly;
		return callAjax('buildConfigurator', sParams, 'POST', "/index.cfm/product/ajax/buildconfigurator");
	}
	else
	{
		showAlert('info', "tConfiguratorNotConfigured", false);
	}
}

function centerPopups() {
	var iWindowHalf = window.innerHeight / 2;
	var iWindowHalfWidth = window.innerWidth / 2;
	$('.modal').each(function() {
		var iPopupHalf = $(this).outerHeight() / 2;
		var iTop = iWindowHalf - iPopupHalf;
		$(this).css('top', iTop + 'px');
		var iPopupHalfWidth = $(this).outerWidth() / 2;
		var iLeft = iWindowHalfWidth - iPopupHalfWidth;
		$(this).css('left', iLeft + 'px');
	});
}

function initPaymentOptions()
{
	var oThumbsCanFinance = $(el('mainContainer')).find(".thumb .thumbFinanceOptions");

	if(oThumbsCanFinance.length > 0)
	{
		oThumbsCanFinance.each(function () {
			loadPaymentOptions($(this).data("amount"), $(this));
		});
	}
}

function loadPaymentOptions(iAmount, oThumb)
{
	uAjax = "/index.cfm/product/ajax/getpaymentoptions";

	var sParams = "&amount=" + iAmount;
	var oCall   = callAjax("getpaymentoptions", sParams, "post");
	oCall.success(function (oData)
	{
		if (oData.errorType == '')
		{
			oThumb.html(oData.html);
		}
		else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function setScanMode(oBtn)
{
	uAjax = "/index.cfm/ajax/setscanmode";

	var bEnable = oBtn.data('enable');
	var sParams = '&enable=' + bEnable;
	var oCall = callAjax("setScanMode", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType === '')
		{
			location.reload();
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function focusEan(oElement, bSelect) {
	$(window).unbind();
	var oScan = document.getElementById(oElement);
	if (!("autofocus" in document.createElement("input"))) {
		oScan.focus();
	}
	if (bSelect) {
		oScan.select();
	}
	$(window).keydown(function(evt) {
		if (bPopupActive == false) {
			oScan.focus();
		}
	});
}

function getValues(oFormEl, sContainer, sFormat) {
	sFormat = typeof sFormat !== 'undefined' ? sFormat : 'ajax';
	oFormEl = typeof sContainer !== 'undefined' ? oFormEl.find(sContainer) : oFormEl;


	var aElements = [];
	oFormEl.find('input,select,textarea').each(function(index, oEl) {
		if (($(oEl).is(':visible') || $(oEl).attr('type') == 'hidden' || $(oEl).data('toggle') == "toggle") && $(oEl).prop('disabled') !== true) {

			//trim vat values
			if($(oEl).attr('name') === "inputVatNumber" || $(oEl).attr('name') === "inputVat" || $(oEl).attr('name') === "inputInvoiceVat")
			{
				var sTrim = $(oEl).val().trim();
				var sCountryCode = sTrim.substr(0,2);
				var sVat = sTrim.substr(2).replace(/[^a-z0-9]/gi,'');
				$(oEl).val(sCountryCode+sVat)
			}

			switch ($(oEl).attr('type')) {
				case "radio":
					if ($(oEl).prop('checked') === true && typeof $(oEl).attr('name') !== 'undefined') {
						aElements.push([$(oEl).attr('name').replace('input', 'edt').split('_')[0], $(oEl).val()]);
					}
					break;
				case "checkbox":
					if ($(oEl).prop('checked') === true && typeof $(oEl).attr('name') !== 'undefined') {
						aElements.push([$(oEl).attr('name').replace('input', 'edt'), $(oEl).val()]);
					}
					else if(($(oEl).data('toggle') == "toggle" || $(oEl).data('checkboxType') == "boolean") && typeof $(oEl).attr("name") !== "undefined"){
						aElements.push([$(oEl).attr('name').replace('input', 'edt'), false])
					}
					break;
				default:
					if (typeof $(oEl).attr('name') === 'undefined') {
						if (typeof $(oEl).attr('id') !== 'undefined') {
							aElements.push([$(oEl).attr('id').replace('input', 'edt'), $(oEl).val()]);
						}
					} else {
						aElements.push([$(oEl).attr('name').replace('input', 'edt'), $(oEl).val()]);
					}
			}
		}
	});

	var sParams = '';
	switch (sFormat) {
		case 'ajax':
			for (var i = 0; i < aElements.length; i++) {
				sParams += '&' + aElements[i][0] + '=' + encodeURIComponent(aElements[i][1]);
			}
			break;
	}
	return sParams;
}

function getUrlParam(url, param) {
	var results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(url);
	if (results == null) {
		return '';
	}
	else {
		return decodeURI(results[1]) || 0;
	}
}

function getValueLabels(oFormEl)
{
	var aElements = [];
	oFormEl.find('input,select,textarea').each(function(index, oEl) {
		if (($(oEl).is(':visible') || $(oEl).attr('type') == 'hidden') && $(oEl).prop('disabled') !== true)
		{
			if (typeof $(oEl).data('name') !== 'undefined' && typeof $(oEl).data('label') !== 'undefined')
			{
				var oValueLabel = {};
				oValueLabel       = {};
				oValueLabel.label = $(oEl).data('label');
				oValueLabel.name  = $(oEl).data('name').replace('input', 'edt');

				switch ($(oEl).attr('type'))
				{
					case "checkbox":
						oValueLabel.value = ($(oEl).prop('checked') === true)?true: false;
						break;
					case "radio":
						oValueLabel.value = ($(oEl).prop('checked') === true)?true: false;
						break;
					default:
						oValueLabel.value = $(oEl).val();
				}
				aElements.push(oValueLabel);
			}
		}
	});

	return aElements;
}

function initButtons()
{
	$(el('mainContainer')).find('button .editTranslation').each(function(index, oEl)
	{
		$(oEl).parents('button').wrap('<div class="editButtonTranslation"></div>');
		oClone = $(oEl).clone();
		oClone.insertBefore($(oEl).parents('button'));
		$(oEl).removeClass('editTranslation');
		$(oEl).find('i').remove();
	});
}

function resetFeedback(oElement) {
	oElement.find('.feedback').hide();
	oElement.find('.error').removeClass('error');
}

function setAction(oContainer, sAction, oExtraVariables) {
	var oAction = oContainer.find('.action')
	oAction.attr('id', sAction);

	// add extra variables to button
	if(typeof oExtraVariables !== 'undefined')
	{
		$.each(oExtraVariables, function(key, value)
		{
			oAction.attr(key, value);
		});
	}
}

function deleteFromWishlist(oBtn)
{
	oBtn.prop("disabled", true);

	var oThumb = oBtn.closest('.thumb');
	var sSkuId = resolveWishlistSkuId(oBtn, oThumb);

	var sParams = '&skuId=' + sSkuId + '&fromlisterorpdp=true';
	var oCall   = callAjax("deleteLine", sParams, "post", "/index.cfm/wishlist/ajax/deleteLine");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			var productArray = (String(sWishlistProducts) || "").split(",");
			var index = productArray.indexOf(sSkuId);
			if (index !== -1) {
				productArray.splice(index, 1);
			}

			sWishlistProducts = productArray.join(",");
			$(document).trigger('wishlistSkuChanged', [String(sSkuId), false]);
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnAddWishlist').removeClass('btnRemoveWishlist');
			oThumb.find('.fa-heart').addClass('fa-heart-o').removeClass('fa-heart');
			ciResponsive.process();
		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
		}
		oBtn.prop('disabled',false);
	});
}

function setScrollHeight(iBottomHeight) {
	var iHeight = document.documentElement.clientHeight - iBottomHeight;
	$('.scroll-pane').css('height', iHeight + 'px');
	if ($('.scroll-pane').length > 0) {
		$('.scroll-pane').jScrollPane({
			mouseWheelSpeed: 40,
			verticalDragMinHeight: 30
		});
	}
}

/**
 * inlineAlert
 * @param {string}  sType         - 'success'|'info'|'warning'|'danger'
 * @param {string}  sMessage
 * @param {boolean} bUnhandled
 * @param {Element} oEl           - element to insert before
 * @param {boolean} bScroll       - scroll into view
 * @param {number}  sTimeout      - ms to wait before starting fade; if null/undefined, no auto fade
 * @param {boolean} bDismissible  - Click to dismiss (default off)
 * @param {number}  fadeMs        - Fade-out duration in ms (default 300)
 **/
function inlineAlert(sType, sMessage, bUnhandled, oEl, bScroll, sTimeout, bDismissible, fadeMs) {
	$('.inlineAlert').remove();

	if (bUnhandled === true) {
		sMessage = 'Error';
	}

	var oError = $(wrapElement(sMessage, 'div'))
		.addClass('inlineAlert alert alert-' + sType)
		.attr('role', 'alert');

	oError.insertBefore($(oEl));
	var bg = null;

	var overlayAlpha = 0.70;
	var el = oError[0];

	// If sType contains productLineWarning, use bg with alpha layer
	if (sType.indexOf('productLineWarning') !== -1) {
		// If so, it is good that it has a timeout
		var bg = getComputedStyle(el).backgroundColor;
		if (typeof sTimeout === 'undefined' || sTimeout === null) {
			sTimeout = 5000;
		}
		// Just to use the theme color and apply alpha layer.
		if (bg) {
			var rgbaBg = bg.startsWith('rgba(')
			? bg.replace(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*[\d.]+\)/, 'rgba($1,$2,$3,' + overlayAlpha + ')')
			: bg.replace(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/, 'rgba($1,$2,$3,' + overlayAlpha + ')');
			oError.css('background-color', rgbaBg);
		}
	}

	if (typeof bScroll === 'undefined' || bScroll) {
		scrollToElement(oError);
	}

	var removed = false;
	var timerId = null;
	var fadeDuration = (typeof fadeMs === 'number' ? fadeMs : 300);

	function dismiss() {
		if (removed) return;
		removed = true;
		if (timerId) clearTimeout(timerId);
		oError.stop(true, true).fadeOut(fadeDuration, function () {
			$(this).remove();
		});
	}

	if (bDismissible === true) {
		oError.css('cursor', 'pointer').one('click', dismiss);
	}
	// If sTimeout is specified, set timer to auto-dismiss, if it is false/null/undefined, do not auto-dismiss
	if (typeof sTimeout === 'number' && sTimeout > 0) {
		timerId = setTimeout(dismiss, sTimeout);
	}

	return oError;
}



function isiOS() {
	return [
	'iPad Simulator',
	'iPhone Simulator',
	'iPod Simulator',
	'iPad',
	'iPhone',
	'iPod'
	].includes(mnavigator.platfor)
	// iPad on iOS 13 detection
	|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function showAlert(sType, sMessage, bUnhandled, sTimeout, oEl) {
	if (bUnhandled === true) {
		var sMessage = 'Error';
	}

	var oError = $(wrapElement(sMessage, 'div')).addClass('popupAlert fade alert alert-' + sType).prepend('<a href="#" class="close" data-dismiss="alert">&times;</a>');

	$('.alertContainer').append(oError);
	setTimeout(function() {
		oError.addClass('in')
	}, 100);
	if (sTimeout !== undefined) {
		setTimeout(function() {
			oError.slideUp(300).remove()
		}, sTimeout);
	}
}

function wrapElement(sElement, sTag) {
	return "<" + sTag + ">" + sElement + "</" + sTag + ">";
}

function clearErrors() {
	$('.popupAlert').alert('close');
}

function clearInlineErrors() {
	$('.inlineAlert ').remove();
}


function removeLineBasketDropdown(lineElement) {
	var lineId = lineElement.attr("line-id");
	var sParams = '&lineId=' + lineId;
	var oCall = callAjax("deleteLine", sParams, "post", "/index.cfm/transaction/ajax");
	oCall.success(function(oData) {
		if (oData.errorType == '')
		{
			getBasketDropdownHeader();
			$(document).trigger( "removeLine",[lineId]);
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}


function showBasketDropdown(html, bOpen, oTarget)
{
	if (typeof bOpen   === 'undefined') bOpen   = true;
	if (typeof oTarget === 'undefined') oTarget = $('#basketDropdown');

	oTarget.html(html).delay(300).queue(function(next)
	{
		if (bOpen)
		{
			oTarget.addClass('open');
			if ($('#basketSidebar').data('no-autoclose'))
			{
				$('#basketSidebar').removeClass('slide-out').addClass('slide-in');
			}
			if (!$('#basketSidebar').data('no-autoclose'))
			{
				setTimeout(function()
				{
					if (oTarget.is(':visible')) oTarget.removeClass('open');
				}, 3000);
			}
		}
		next();
	});
}

function getBasketDropdownHeader()
{
	var oSecondCall = callAjax("basketDropdown", '', "post", '/index.cfm/transaction/ajax/basketdropdown');
	oSecondCall.success(function(oDataDropdown) {
		if (oDataDropdown.errorType == '') {
			$('#basketDropdown').html(oDataDropdown.html);
		} else {
			showAlert('error', oDataDropdown.errorMessage, oDataDropdown.errorUnhandled);
		}
	});
}

function removeFromwishlist(sProductId)
{
	uAjax = "/index.cfm/customer/ajax/removefromwishlist";

	var sParams = '&productId=' + sProductId;
	var oCall = callAjax("removeFromwishlist", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '')
		{
			if($('.wishlistContainer').length > 0)
			{
				$('.wishlistContainer').replaceWith(oData.html);

				ciResponsive.process();
			}
			else if (typeof $('.thumb[data-product="' + sProductId + '"]') !== 'undefined')
			{
				var oThumb = $('.thumb[data-product="' + sProductId + '"]');
				oThumb.find('.fa-heart').addClass('fa-heart-o').removeClass('fa-heart');
				oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnAddWishlist').removeClass('btnRemoveWishlist');
			}
			if($('.wishlistQuantity').length > 0)
			{
				$('.wishlistQuantity').html('<span>'+oData.wishlistQuantity+'</span>');
				if(oData.wishlistQuantity == 0)
				{
					$('.wishlistQuantity').hide();
				}
				else
				{
					$('.wishlistQuantity').show();
				}
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function suggestSearch(oEl,keyword)
{
	if(keyword.length > 2)
	{
		var sParams = '&keyword=' + keyword;
		var oCall   = callAjax('suggest', sParams, 'post', "/index.cfm/product/ajax/suggest");

		oCall.success(function(oData)
		{
			if (oData.errorType === '' && oData.html !== '')
			{
				if(!$(el('suggest')).length)
				{
					var oSearchForm = oEl.parents('form');
					oSearchForm.append('<div id="suggest"></div>');
				}
				$(el('suggest')).html(oData.html);
			}
			else if (oData.errorType === 'noResult')
			{
				$(el('suggest')).remove();
			}
		});
	}
}

function suggestKeyHandler(oEl, iKeyCode, sKeyword)
{
	var oFirst    = $(el('suggest')).find('ul li:first');
	var oLast     = $(el('suggest')).find('ul li:last');
	var oSelected = $(el('suggest')).find('ul li.selected');

	switch (iKeyCode)
	{
		case 13:
			if(oSelected.length > 0)
			{
				// Submit search from term
				if(oSelected.hasClass('suggestTerm'))
				{
					var oForm        = $(el('suggest')).parents('form');
					var oSearchInput = $('header input[name="keyword"]');

					oSearchInput.val(oSelected.text().trim());
					oForm.submit();
				}

				// Go to product detail
				if(oSelected.hasClass('suggestLine'))
				{
					var sUrl = oSelected.find('.colourURL').attr('href');
					window.location.href = sUrl;
				}
			}
			break;
		case 38:
			if(oSelected.length > 0)
			{
				if(!oSelected.is('li:first-of-type'))
				{
					oSelected.removeClass('selected').prevAll('li:first').addClass('selected');
				}
				else
				{
					oSelected.removeClass('selected');
					oLast.addClass('selected');
				}
			}
			else
			{
				oLast.addClass('selected');
			}
			break;

		case 40:
			if(oSelected.length > 0)
			{
				if(!oSelected.is('li:last-of-type'))
				{
					oSelected.removeClass('selected').nextAll('li:first').addClass('selected');
				}
				else
				{
					oSelected.removeClass('selected');
					oFirst.addClass('selected');
				}
			}
			else
			{
				oFirst.addClass('selected');
			}
			break;

		default:
			suggestSearch(oEl,sKeyword);
	}
}

function subscribe(frmSubscribe) {
	clearErrors();

	// Disable submit button to prevent double-click
	$('#btnSubscribe').prop('disabled', true);

	var bValid = validateForm(frmSubscribe);
	if (bValid) {
		var sEmail = $('#inputEmailSubscribe').val();
		var sName = $('#inputFirstNameSubscribe').val();

		if ($(el('inputSurnameSubscribe')).val()) {
			sName += ' ' + $(el('inputSurnameSubscribe')).val();
		}

		uAjax = "/index.cfm/customer/ajax/subscribe";
		// sName is only forwarded to the customers/subscribe REST call; firstName/lastName are what
		// customer/ajax/subscribe writes onto the customer record itself. Sending only sName left the
		// footer signup saving an email with no name against the customer (AVA26-10).
		// Both fields are optional: not every theme renders them, and .val() on a missing input
		// returns undefined, which would post the literal "undefined" and get written as the name.
		// The handler only guards sName against that, so these have to fall back here.
		// Encoded because the body is form-urlencoded: a raw "+" in an address arrives as a space and
		// fails the server-side format check, and a "&" in a name would cut the value short.
		var sParams = '&sEmail=' + encodeURIComponent(sEmail || '') + '&sName=' + encodeURIComponent(sName || '')
			+ '&firstName=' + encodeURIComponent($('#inputFirstNameSubscribe').val() || '')
			+ '&lastName=' + encodeURIComponent($(el('inputSurnameSubscribe')).val() || '');
		var oCall = callAjax('subscribe', sParams, 'post');
		oCall.success(function(oData) {
			$('.footerSubscribe').addClass('newsletterSubmitted')

			if (oData.errorType != '')
			{
				$('.footerSubscribe').addClass('newsletterSubmittedError')
				$('.footerSubscribe .newsletterText').text('');
				$('.footerSubscribe .newsletterSubText').text(oData.errorMessage);
				$('.footerSubscribe .newsletterTextTitle').text('');
				$('.footerSubscribe .newsletterSubTextWithInfo').text(oData.errorMessage);
				$('.footerSubscribe .newsletterForm, .footerSubscribe #btnSubscribe').remove();
			}
			else
			{
				$(document).trigger("subscribe",[sEmail]);

				$('#frmSubscribe input[type="text"]').val('');
				$('.footerSubscribe .newsletterText').text('');
				$('.footerSubscribe .newsletterSubText').text(tNewsletterSubscribed);
				$('.footerSubscribe .newsletterForm, .footerSubscribe #btnSubscribe').remove();
				$('.footerSubscribe .newsletterTextTitle').text(tNewsletterSubscribedTitle.replace("{email}","<a href='mailto:" + sEmail + "'>" + sEmail + "</a>").replace("{firstName}",sName ? sName : '').replaceAll("{br}","<br>"));
				$('.footerSubscribe .newsletterSubTextWithInfo').html(tNewsletterSubscribedWithInfo.replace("{email}","<a href='mailto:" + sEmail + "'>" + sEmail + "</a>").replace("{firstName}",sName ? sName : '').replaceAll("{br}","<br>"));
			}
			$('#btnSubscribe').prop('disabled', false);
		});
	}
	else
	{
		showAlert('error', tSubscribeInvalidInput, true);
		// Re-enable button if validation fails
		$('#btnSubscribe').prop('disabled', false);
	}
}

function validateBasketDropdownProductLineQuantity(iQty,iMultiplier,iStock,sLineId)
{
	if(isNaN(iQty) !== true && iQty != ""){

		iQty = Math.abs(iQty);
		iQty = (iMultiplier > 1 ? iQty*iMultiplier : iQty);
		iQty = (iStock < iQty && iStock > 0 ? iStock : iQty);

		changeBasketDropdownProductLineQuantity(sLineId, iQty);
	}
}

function changeBasketDropdownProductLineQuantity(sLineId, iQty)
{

	clearErrors();

	var buttons = $('[BasketDropdownProductLineId=' + sLineId + ']').parent().find('.cartDropdownProductLineQuantityBtn');
	buttons.each(function(){
		$(this).prop('disabled', true);
	});

	$('.basketdropdownModal').modal('hide');

	// AJAX call
	uAjax       = "/index.cfm/ajax/changeBasketDropdownProductLineQuantity";
	var sParams = '&lineId=' + sLineId + '&lineQty=' + iQty;
	var oCall   = callAjax("changeBasketDropdownProductLineQuantity", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$('#basketDropdown').html(oData.html);
			$('.basketdropdownModal').modal('show');
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);

		buttons.each(function(){
			$(this).prop('disabled', false);
		});
	});
}

function confirmModal(variable, callbackfunction) {
	$('#confirmModal').modal('toggle');
	$('#confirmModal #btnYes').one('click', function() {
		if(typeof callbackfunction.name !== 'undefined')
		{
			var callbackfunctionName = callbackfunction.name;
		}
		else
		{
			// IE fallback: .name not supported..
			var callbackfunctionName = callbackfunction.toString().match(/^function\s*([^\s(]+)/)[1];
		}
		$(document).trigger(callbackfunctionName,variable);
		callbackfunction(variable);
		$('#confirmModal').modal('toggle');
	});
}

function showFullScreenPopup(text, title, className) {
	if (className === undefined) {
		className = '';
	}
	var maxHeight = $(window).height() - 100;
	if (maxHeight > 1100) {
		maxHeight = 1100;
	}
	var maxWidth = $(window).width();
	if (maxWidth > 1100) {
		maxWidth = 1100;
	}
	// Flex-column layout on .modal-dialog: header takes natural height, body fills the rest via flex:1.
	// This replaces the previous fixed pixel subtractions (which left ~70px of dead space).
	var dialogStyle = 'display:flex;flex-direction:column;height:100%;margin:0;';
	var headerStyle = 'flex-shrink:0;';
	var bodyStyle   = 'flex:1 1 auto;min-height:0;overflow-y:auto;';
	$('<div class="modal hide fade ' + className + '" style="width: ' + maxWidth + 'px; height:' + maxHeight + 'px;margin-left:0px;">' +
		'<div class="modal-dialog modal-lg" style="' + dialogStyle + '">' +
			'<div class="modal-header" style="' + headerStyle + '"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">x</button><h3 id="modalTitle">' + title + '</h3></div>' +
			'<div class="modal-body" style="' + bodyStyle + '">' + text + '</div>' +
		'</div>' +
	'</div>').modal().appendTo('#mainContainer');
	centerPopups();
}

function editTranslation(translation)
{
	if(typeof translation.data('popover') === 'undefined')
	{
		translation.popover({
		html: true,
		placement: 'bottom',
		title: '<i class="fa fa-arrows translation-drag-icon"></i> Edit translation',
		content: '<div class="edit"><textarea class="translationText"></textarea><button class="btn btn-primary btnEditTranslation" type="submit">Save</button><button class="btn btn-danger btnCancelEditTranslation pull-right" type="submit">Cancel</button></div>'
		}).popover('show');
	}
	$('.popover.fade.bottom.in').css('left', '0')
	var text = translation.text();
	translation.next().find('textarea').val(text);
	$('.popover.fade.bottom.in').draggable({
		handle: ".popover-title",
	});
}

function saveTranslation(button) {
	var orgElement = button.closest('.popover').prev();
	if (typeof orgElement.data("code") == 'undefined') {
		orgElement = button.closest('.popover').prev().find('.editTranslation');
	}
	var translationCode = orgElement.data("code");
	var displayText = button.prev().val();
	var translationText = displayText.replace(/(?:\r\n|\r|\n)/g, '<br />');

	uAjax = "/" + sCurrentLanguageCode + "/ajax/updatetranslation";

	var sParams = '&sTranslationCode=' + translationCode + '&sTranslationText=' + encodeURI(translationText);
	var oCall = callAjax('updatetranslation', sParams, 'post');
	oCall.success(function(oData) {
		if (oData.errorType != '') {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		} else {
			showAlert('success', 'Translation updated', false, 3000);
			orgElement.text(displayText);
			$('.popover').remove();
		}
	});
}

var swatchImageTimeout;
function selectSwatch(swatch)
{
	var ciSrc      = swatch.data('ci-src');
	var original   = swatch.data('original');
	var colourLink = swatch.data('url');
	var thumb      = swatch.closest('.thumbnail');


	// Point the hover image at the colour just picked, but only within this thumb:
	// unscoped selectors here re-pointed every thumb in the list to the same colour index.
	if (thumb.find('.productImageSecondContainer').length > 0) {
		var swatchIndex = swatch.data('current-index');
		thumb.find('.productImageSecondContainer').removeClass('secondSelected');
		var targetSecondaryImage = thumb.find('.productImageSecondary[data-current-index="' + swatchIndex + '"]');
		targetSecondaryImage.closest('.productImageSecondContainer').addClass('secondSelected');
	}

	if(typeof ciSrc === "undefined"){
		ciSrc = 'https://' + original.split('/https://')[1];
	}
	var thumbWidth = getBoundingClientRect(thumb.find('.productImage'),"width");
	var thumbHeight = getBoundingClientRect(thumb.find('.productImage'),"height");
	thumb.children('a').css('display','block').width(thumbWidth).height(thumbHeight);
	var newThumbImage = thumb.find('.productImage').clone().removeClass('ci-image').removeClass('ci-image-loaded').removeClass('lazyloaded').prop('src','/styles/images/content/spacer.png').attr('data-src',original).attr('ci-src',ciSrc).removeAttr('srcset').removeAttr('data-srcset').removeAttr('data-src');
	if(typeof colourLink !== "undefined")
	{
		thumb.find('a').prop('href',colourLink);
		thumb.find('a').removeAttr('onclick');
		thumb.find('a').attr('onClick', 'window.open("' + colourLink + '", "_self")');
	}

	var originalImage = thumb.find('.productImage');
	var newThumbImage = originalImage.clone()
		.removeClass('ci-image ci-image-loaded lazyloaded')
		.prop('src', '/styles/images/content/spacer.png')
		.attr('data-src', original)
		.attr('ci-src', ciSrc)
		.removeAttr('srcset data-srcset data-src')
		.css({
    		width: thumbWidth + 'px',
    		height: thumbHeight + 'px'
		})
		.removeAttr('width')
		.removeAttr('height');

	if(typeof colourLink !== "undefined")
	{
		thumb.find('a').removeAttr('onclick');
		thumb.find('a').attr('onClick', 'window.open("' + colourLink + '", "_self")');
	}

	var replaceContainer = (originalImage.parent(".ci-image-wrapper").length > 0) ? originalImage.parent(".ci-image-wrapper") : originalImage;
	replaceContainer.replaceWith(newThumbImage);

	// Clear any previous timeout
	if (swatchImageTimeout) clearTimeout(swatchImageTimeout);

	// After timeout, set the real image src
	swatchImageTimeout = setTimeout(function() {
		newThumbImage.prop('src', original);
		ciResponsive.process();
	}, 100);

	thumb.find('a').prop('href', colourLink);

	// Set correct price
	var sPromoPrice = swatch.data('pricePromo').toString();
	var nPromoPrice = parseFloat(sPromoPrice.replace(",", ".").replace(",-", ".00"));
	var sCurrentPrice = swatch.data('priceCurrent');
	var diffPricesStandard = swatch.data('diffPricesStandard');
	var diffPricesPromo = swatch.data('diffPricesPromo');
	var bRecommendedPrice = (typeof swatch.data('priceRecommended') !== 'undefined');
	var sRecommendedPrice = bRecommendedPrice ? swatch.data('priceRecommended') : 0;
	var bCurrencySignFirst  = (typeof swatch.data('currencySignFirst') !== 'undefined' && swatch.data('currencySignFirst'));
	var sCurrentPriceString = (bCurrencySignFirst) ? sCurrencySign + " " + sCurrentPrice : sCurrentPrice + sCurrencySign;
	var sPromoPriceString   = (bCurrencySignFirst) ? sCurrencySign + " " + sPromoPrice : sPromoPrice + sCurrencySign;
	var sPriceHTML = '';
	if(nPromoPrice > 0 && (!bRecommendedPrice || sRecommendedPrice == 0))
	{
		sPriceHTML += '<span class="strike-through">' + sCurrentPriceString + '</span>&nbsp;';
		sPriceHTML += '<span>';
		if(diffPricesPromo)
		{
			sPriceHTML +=  sPricePromoFrom + ' ';
		}
		sPriceHTML += sPromoPriceString + '</span>';
	} else
	{
		sPriceHTML += '<span>';
		if(diffPricesStandard)
		{
			sPriceHTML +=  sPriceStandardFrom + ' ';
		}
		sPriceHTML += sCurrentPriceString + '</span>';
	}
	if(bRecommendedPrice) {
		sPriceHTML = '';
		var sStandardPrice = swatch.data('priceStandard');
		var sStandardPriceString   = (bCurrencySignFirst) ? sCurrencySign + " " + sStandardPrice : sStandardPrice + sCurrencySign;
		if (nPromoPrice == sRecommendedPrice && nPromoPrice > 0) {
			sPriceHTML += '<span class="promoPrice">' + sPromoPriceString.replace('.',',') + '</span>'
			sPriceHTML += '<span class="standardPrice"><span class="recommendedPriceLabel">' + sRecommendedPriceLabel + ':&nbsp;</span>' + sStandardPriceString.replace('.',',') + '</span></span>'
		} else if (nPromoPrice != sRecommendedPrice && nPromoPrice > 0) {
			sPriceHTML += '<span class="recommendedPrice strike-through">' + sStandardPriceString.replace('.',',') + '</span>&nbsp;'
			sPriceHTML += '<span class="promoPrice">' + sPromoPriceString.replace('.',',') + '</span>'
		} else {
			sPriceHTML += '<span class="standardPrice">' + sStandardPriceString.replace('.',',') + '</span>'
		}

	}

	oThumbPrice = swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)');

	updateSwatchPrice(oThumbPrice,sPriceHTML,nPromoPrice);
	const percentage = $(swatch).data('promo-percentage');
	// Check new promo percentage
	if (percentage && percentage !== '0') {
		const $thumb = $(swatch).closest('.thumb');
		const $target = $thumb.find('.discount strong').length
			? $thumb.find('.discount strong')
			: $thumb.find('.discount');

		$target.text('- ' + percentage);
	}
	if(swatch.hasClass('trigger')) {
		// check if the extra class hasPromo needs to be added
		if (nPromoPrice > 0 && (!bRecommendedPrice || sRecommendedPrice == 0)) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasPromo');
			thumb.find('.discountLabel,.discount').show();
		} else if(nPromoPrice === sRecommendedPrice && nPromoPrice > 0) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasPromo');
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasRecommendedLabel');
			thumb.find('.discountLabel,.discount').hide();
		} else if (sStandardPrice < sRecommendedPrice) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasRecommendedLabel');
			if (nPromoPrice > 0) {
				swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasPromo');
				thumb.find('.discountLabel,.discount').show();
			} else {
				swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasPromo');
				thumb.find('.discountLabel,.discount').hide();
			}
		} else if (sRecommendedPrice > 0 && sRecommendedPrice != sCurrentPrice) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasPromo');
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasRecommendedLabel');
			thumb.find('.discountLabel,.discount').show();
		} else {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasRecommendedLabel');
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasPromo');
			thumb.find('.discountLabel,.discount').hide();
		}

		// check if we need to add the overlay
		if (swatch.data('overlayImage') != '') {
			var overlayImage = swatch.data('overlayImage');
			var overlayText = swatch.data('overlayText');

			if (swatch.closest('.thumb').find('.overlay').length > 0) swatch.closest('.thumb').find('.overlay').closest('a').remove();

			// add overlay code
			var overlayHtml = '<a href="' + colourLink + '">';
			overlayHtml += '<img src="' + overlayImage + '" alt="' + overlayText + '" class="overlay">';
			overlayHtml += '</a>';

			swatch.closest('.thumb').find('.productImage').closest('a').after(overlayHtml);
		}
		else if (swatch.closest('.thumb').find('.overlay').length > 0) {
			swatch.closest('.thumb').find('.overlay').closest('a').remove();
		}
		var minPercentagePromo = (typeof swatch.data('minPercentagePromo') !== 'undefined' ? swatch.data('minPercentagePromo') : 0);
		if (minPercentagePromo !== 0) {
			var discountPercentage = ((sCurrentPrice - nPromoPrice)/sCurrentPrice) * 100;
			discountPercentage     = (Math.round(discountPercentage / 5)) * 5;
			if (minPercentagePromo >= discountPercentage) {
				oThumbPrice.find('.discountLabel,.discount').hide();
			}
		}
	}

	// set selected class on active swatch
	thumb.find('.swatch').removeClass('selected');
	swatch.addClass('selected');

	if (swatch.data('colour-id')) {
		// Swap product dropdowns for each product sizes
		swatch.closest(".thumb").find(".sizeWrapper").addClass("hide");
		$('.sizeWrapper .selectedSizeWrapper .selectedSize:not(.hide)').addClass('hide');
		swatch.closest(".swatchesContainer").find(".selectedSkuId").removeAttr('data-skuId');
		thumb.find(".sizeWrapper.colourId" + swatch.data('colour-id') + ".hide").removeClass("hide")
		$(".sizeWrapper .sizeTitle.hide").removeClass('hide');
		$(".sizeWrapper .thumbSizeItem").removeClass('selected');
	}
}

	// Swatch click product thumbs
	$(el('mainContainer')).on('click','.dropdown-menu .thumbSizeItem',function(){
		handleThumbSizeChange($(this));
	});

	$(el('mainContainer')).on('click','.shopthelookthumb .dropdown-menu .thumbSizeItem',function(){
		handleShopTheLookThumbSizeChange($(this));
	});


	function handleThumbSizeChange(sizeEl) {
		var sizeElProductId = sizeEl.data('product-id');
		var thumbEl = $(el('mainContainer')).find(".thumb[data-product='" + sizeElProductId + "']");
		var selectedSizeSkuId = sizeEl.data('value');
		var elDropdownItems = sizeEl.closest('.dropdown-menu').find('.thumbSizeItem');
		var standardPrice = parseFloat(sizeEl.data('price-standard'));
		var currentPrice = parseFloat(sizeEl.data('price-current'));
		var bRecommendedPrice = (typeof sizeEl.data('price-recommended') !== 'undefined');
		var recommendedPrice = bRecommendedPrice ? parseFloat(sizeEl.data('price-recommended')) : 0;
		var bInstock = sizeEl.data('instock');

		elDropdownItems.removeClass('selected');
		sizeEl.addClass('selected');
		thumbEl.find('.selectedSkuId').attr('data-skuId', selectedSizeSkuId);
		sizeEl.parents('.thumbSetting').find('.swatchesContainer .selectedSkuId').attr('data-product-id', sizeEl.data('product-id'));

		var oSizeWrapper = sizeEl.parents('.sizeWrapper');
		oSizeWrapper.find('.selectedSizeWrapper .sizeTitle:not(.hide)').addClass('hide');
		oSizeWrapper.find('.selectedSizeWrapper .selectedSize').text(sizeEl.text());
		oSizeWrapper.find('.selectedSizeWrapper .selectedSize.hide').removeClass('hide');
		if(bEnableNewWishlist) {
			if (sWishlistProducts.indexOf(selectedSizeSkuId) > 0) {
				thumbEl.find('.btnAddWishlistWrapper .btn-add i').addClass('fa-heart').removeClass('fa-heart-o');
				thumbEl.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
			} else {
				thumbEl.find('.btnAddWishlistWrapper .btn-add i').addClass('fa-heart-o').removeClass('fa-heart');
				thumbEl.find('.btnAddWishlistWrapper .btn-add').addClass('btnAddWishlist').removeClass('btnRemoveWishlist');
			}
		}
		if(bRecommendedPrice) {
			var sPricesHtml = ''
			if ((standardPrice != currentPrice) && currentPrice == recommendedPrice) {
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).addClass('hasRecommendedLabel');
				// No trigger overlay
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).removeClass('hasPromo');
				thumbEl.find('.discountLabel,.discount').hide();
				sPricesHtml += '<span class="promoPrice">' + sCurrencySign + ' ' + currentPrice.toFixed(2).replace('.',',') + '</span>'
				sPricesHtml += '<span class="standardPrice"><span class="recommendedPriceLabel">' + sRecommendedPriceLabel + ':&nbsp;</span>' + sCurrencySign + ' ' + standardPrice.toFixed(2).replace('.',',') + '</span></span>'
			} else if ((standardPrice != currentPrice) && currentPrice != recommendedPrice) {
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).addClass('hasPromo');
				thumbEl.find('.discountLabel,.discount').show();
				sPricesHtml += '<div class="thumbPriceWrapperLabel"><span class="strike-through">' + sCurrencySign + " " + parseFloat(standardPrice).toFixed(2).replace('.',',') + '</span><span>&nbsp;' + sCurrencySign + " " + parseFloat(currentPrice).toFixed(2).replace('.',',') + '</span></div>'
			} else if (standardPrice < recommendedPrice) {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + standardPrice.toFixed(2).replace('.',',') + '</span>'
			} else {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + currentPrice.toFixed(2).replace('.',',') + '</span>'
			}
			$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).html(sPricesHtml);
		}

		if(typeof bInstock !== 'undefined')
		{
			if(bInstock)
			{
				thumbEl.find('.thumbStockLabel .instockLabel').show();
				thumbEl.find('.thumbStockLabel .notInstockLabel').hide();
			}
			else
			{
				thumbEl.find('.thumbStockLabel .instockLabel').hide();
				thumbEl.find('.thumbStockLabel .notInstockLabel').show();
			}
		}
		if (thumbEl.find('.sizesA2bBtn').length > 0) {
			thumbEl.find('.btn[data-add="basket"]').trigger('click');
		}
	}

	function handleShopTheLookThumbSizeChange(sizeEl) {
		var sizeElProductId = sizeEl.data('product-id');
		var thumbEl = $(el('mainContainer')).find(".shopthelookthumb[data-product='" + sizeElProductId + "']");
		var selectedSizeSkuId = sizeEl.data('value');
		var elDropdownItems = sizeEl.closest('.dropdown-menu').find('.thumbSizeItem');
		var standardPrice = parseFloat(sizeEl.data('price-standard'));
		var currentPrice = parseFloat(sizeEl.data('price-current'));
		var bRecommendedPrice = (typeof sizeEl.data('price-recommended') !== 'undefined');
		var recommendedPrice = bRecommendedPrice ? parseFloat(sizeEl.data('price-recommended')) : 0;
		var bInstock = sizeEl.data('instock');

		elDropdownItems.removeClass('selected');
		sizeEl.addClass('selected');
		thumbEl.find('.selectedSkuId').attr('data-skuId', selectedSizeSkuId);
		sizeEl.parents('.thumbSetting').find('.swatchesContainer .selectedSkuId').attr('data-product-id', sizeEl.data('product-id'));

		var oSizeWrapper = sizeEl.parents('.sizeWrapper');
		oSizeWrapper.find('.selectedSizeWrapper .sizeTitle:not(.hide)').addClass('hide');
		oSizeWrapper.find('.selectedSizeWrapper .selectedSize').text(sizeEl.text());
		oSizeWrapper.find('.selectedSizeWrapper .selectedSize.hide').removeClass('hide');

		if(bEnableNewWishlist) {
			if (sWishlistProducts.indexOf(selectedSizeSkuId) > 0) {
				thumbEl.find('.btnAddWishlistWrapper .btn-add i').addClass('fa-heart').removeClass('fa-heart-o');
				thumbEl.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
			} else {
				thumbEl.find('.btnAddWishlistWrapper .btn-add i').addClass('fa-heart-o').removeClass('fa-heart');
				thumbEl.find('.btnAddWishlistWrapper .btn-add').addClass('btnAddWishlist').removeClass('btnRemoveWishlist');
			}
		}
		if(bRecommendedPrice) {
			var sPricesHtml = ''
			if ((standardPrice != currentPrice) && currentPrice == recommendedPrice) {
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).addClass('hasRecommendedLabel');
				// No trigger overlay
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).removeClass('hasPromo');
				thumbEl.find('.discountLabel,.discount').hide();
				sPricesHtml += '<span class="promoPrice">' + sCurrencySign + ' ' + currentPrice.toFixed(2).replace('.',',') + '</span>'
				sPricesHtml += '<span class="standardPrice"><span class="recommendedPriceLabel">' + sRecommendedPriceLabel + ':&nbsp;</span>' + sCurrencySign + ' ' + standardPrice.toFixed(2).replace('.',',') + '</span></span>'
			} else if ((standardPrice != currentPrice) && currentPrice != recommendedPrice) {
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).addClass('hasPromo');
				thumbEl.find('.discountLabel,.discount').show();
				sPricesHtml += '<div class="thumbPriceWrapperLabel"><span class="strike-through">' + sCurrencySign + " " + parseFloat(standardPrice).toFixed(2).replace('.',',') + '</span><span>&nbsp;' + sCurrencySign + " " + parseFloat(currentPrice).toFixed(2).replace('.',',') + '</span></div>'
			} else if (standardPrice < recommendedPrice) {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + standardPrice.toFixed(2).replace('.',',') + '</span>'
			} else {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + currentPrice.toFixed(2).replace('.',',') + '</span>'
			}
			$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).html(sPricesHtml);
		}

		if(typeof bInstock !== 'undefined')
		{
			if(bInstock)
			{
				thumbEl.find('.thumbStockLabel .instockLabel').show();
				thumbEl.find('.thumbStockLabel .notInstockLabel').hide();
			}
			else
			{
				thumbEl.find('.thumbStockLabel .instockLabel').hide();
				thumbEl.find('.thumbStockLabel .notInstockLabel').show();
			}
		}
	}


// set header of popup
function setPopupHeader(oPopup, sTitle, sSubtitle)
{
	oPopup.find('.modal-header').html(sTitle);
	oPopup.find('.modal-body .subtitle').html(sSubtitle);
}

// set header of popup
function setPopupContent(oPopup, sContent)
{
	oPopup.find('.content').html(sContent);
}

function removeParam(key, sourceURL) {
	var rtn = sourceURL.split("?")[0],
		param,
		params_arr = [],
		queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
	if (queryString !== "") {
		params_arr = queryString.split("&");
		for (var i = params_arr.length - 1; i >= 0; i -= 1) {
			param = params_arr[i].split("=")[0];
			if (param === key) {
				params_arr.splice(i, 1);
			}
		}
		if (params_arr.length > 0) {
			rtn = rtn + "?" + params_arr.join("&");
		}
	}
	return rtn;
}

function scrollToElement(oEl)
{
	var iHeightFixedHeader = 0;
	if($('.fixedActive').length > 0)
	{
		iHeightFixedHeader = $('.fixedActive').outerHeight();
	}

	$('body,html').animate({
		scrollTop: oEl.offset().top - oEl.outerHeight()/2 - iHeightFixedHeader
	}, 400);
}

function showContentPopup(sPageName) {
	// Get contentpage to show in popup, if exists
	var sParams = '&pageName=' + sPageName;

	var oCall = callAjax('popup', sParams, 'post', '/index.cfm/ajax/popup');
	oCall.success(function(oData) {
		if (oData.errorType === '') {
			showFullScreenPopup(oData.html, '', 'contentPopup');
			initLazyResponsiveLoad(true,'content');

			if (typeof initFlexSliders === "function") initFlexSliders();
			if (typeof initFeaturedProducts === "function") initFeaturedProducts();
			if (typeof initFeaturedProductsGridSlider === "function") initFeaturedProductsGridSlider();
			if (typeof initForms === "function") initForms();
			if (typeof initContentEventHandlers === "function") initContentEventHandlers();
			if (typeof initHotSpotImages === "function") initHotSpotImages();
			if (typeof initPaymentOptions === "function") initPaymentOptions();
			ciResponsive.process();

			setTimeout(function() {
				centerPopups();
			}, 100);

		}
	});
}

var bMouseleaveCountShown = 0
function showIdleBasketPopup(bMouseleave)
{
	if((bMouseleave && bMouseleaveCountShown == 0) || !bMouseleave)
	{
		if(bMouseleave) bMouseleaveCountShown ++;

		var oCall = callAjax('showidlebasketpopup', "", 'post','/index.cfm/transaction/ajax/showidlebasketpopup');
		oCall.success(function(oData) {
			if (oData.html !==  "undefined" && oData.html !== "")
				{
				$(oData.html).modal().appendTo('#mainContainer');

				setTimeout(function() {
					centerPopups();
				}, 100);
			}
			else
			{
				if(bMouseleave) bMouseleaveCountShown --;
			}
		});
	}
}

function showSelectedWishlistPopup()
{
	var oCall = callAjax('showselectedwishlistpopup', "", 'post','/index.cfm/wishlist/ajax/showselectedwishlistpopup');
	oCall.success(function(oData)
	{
		if (oData.errorType === "")
		{
			clearErrors();

			$(el("rememberWishlistModal")).remove();
			$(el("mainContainer")).append(oData.html);
			$(el("rememberWishlistModal")).modal();

			centerPopups();
		}
		else
		{
			showAlert("error", oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function rememberWishlist(oBtn)
{
	oBtn.prop('disabled', true);

	var sParams = '&id=' + $(el("wishlistsDropdown")).val();
	var oCall = callAjax('rememberwishlist', sParams, 'post','/index.cfm/wishlist/ajax/rememberwishlist');
	oCall.success(function(oData)
	{
		if (oData.errorType === "")
		{
			clearErrors();
			if ($(".wishlistEditProducts").length > 0) {
				window.location = oData.redirectUrl;
			} else {
				location.reload();
			}
		}
		else
		{
			showAlert("error", oData.errorMessage, oData.errorUnhandled);
			oBtn.prop('disabled', false);
		}

	});
}

function showCustomerPopup(sPopupType) {
	// Get contentpage to show in popup, if exists
	uAjax = '/index.cfm/ajax/popup';
	var sParams = '&popupType=' + sPopupType;
	var oCall = callAjax('popup', sParams, 'post');
	oCall.success(function(oData) {
		if (oData.errorType === '') {
			showFullScreenPopup(oData.html, '', 'customerPopup');
			centerPopups();
		}
	});
}

function updateSwatchPrice(oThumbPrice,sPriceHTML,nPromoPrice)
{
	if(oThumbPrice.find('.discountLabel,.discount').length > 0)
	{
		var oDiscountLabelClone = $(oThumbPrice).find('.discountLabel,.discount').clone();
	}

	oThumbPrice.html(sPriceHTML);
	oThumbPrice.append(oDiscountLabelClone);
	if(nPromoPrice > 0)
	{
		oThumbPrice.find('.discountLabel,.discount').show();
	}
	else
	{
		oThumbPrice.find('.discountLabel,.discount').hide();
	}
}

function detectBrowserLanguage()
{
	var sBrowserLanguage = '';
	if(typeof navigator.browserLanguage !== 'undefined')
	{
		// IE fallback
		sBrowserLanguage = navigator.browserLanguage;
	}
	else if(typeof navigator.language !== 'undefined')
	{
		sBrowserLanguage = navigator.language
	}

	return sBrowserLanguage;
}

function getSelectedAddons(bGetVisibleAddonsOnly)
{
	var bVisibleOnly = (typeof bGetVisibleAddonsOnly !== "undefined") ? bGetVisibleAddonsOnly : false;
	var oAddons = (bVisibleOnly) ? $('.addons:visible') : $('.addons');
	var aLines = [];
	oAddons.find('input,select,textarea').each(function()
	{
		if(!$(this).hasClass("addon-product-qty-picker"))
		{
			var bActive        = false;
			var sType          = $(this).attr('type');
			var sSku           = "";

			if($(this).is('input') || $(this).is('textarea'))
			{
				if(sType === 'checkbox' && $(this).is(":checked"))
				{
					bActive = true;
					sSku =  $(this).data('sku');
				}
				else if(sType === 'text' && $.trim($(this).val()) !== "")
				{
					bActive = true;
					sSku =  $(this).data('sku');
				}
				else if(sType === 'radio'  && $(this).is(":checked"))
				{
					bActive = true;
					sSku    = $(this).val();
					skyQty  = $(this).closest(".control-group").find(".addon-product-qty-picker").val();
				}
			}
			else if($(this).is('select') && $(this).val() !== "")
			{
				bActive = true;
				sSku =  $(this).val();
			}

			if(bActive)
			{
				var oLine = {};
				oLine.description = '+ ' + $(this).data('description');
				oLine.quantity = (typeof skyQty !== "undefined") ? skyQty : (typeof getSkuQty !== "undefined") ? getSkuQty() : 1;
				oLine.skuId = sSku;
				oLine.sample = false;
				oLine.entryId = "";

				if($(this).is(':radio'))
				{
					oLine.comment = $(this).data('text') ? $(this).data('text') : "";
				}
				if($(this).data('requirestext'))
				{
					oLine.comment = $.trim($(this).val());
				}
				if($(this).is('select'))
				{
					oLine.comment = $.trim($(this).find('option:selected').text());
				}
				aLines.push(oLine);
			}
		}
	});

	return aLines;
}

function scanBarCode(sBarCode)
{
	var sParams = '&barcode=' + sBarCode;
	var oCall = callAjax("scanBarCode", sParams, "get","/index.cfm/product/ajax/scanBarCode");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === '' && typeof oData.redirect !== 'undefined' && oData.redirect !== "")
		{
			window.location = oData.redirect;
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
		else if(oData.errorType !== '')
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function sendPicturePack(ids,button)
{

	var sParams = '&skuIds=' + ids;
	sParams += "&email=" + button.closest('.modal').find('.picturePackEmail').val();

	var oCall = callAjax("sendPicturePack", sParams, "post","/index.cfm/customer/ajax/sendPicturePack");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === 'info')
		{

			button.closest('.modal').modal('hide');
			button.prop('disabled',false);
			inlineAlert('info', oData.errorMessage, false, '.sendPicturePack');
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			button.prop('disabled',false);
		}
	});
}

function setSlider(oSlider, containerWidth, bShowNextSlide,asNavFor)
{
	var oSlides            = oSlider.find('.slides li.thumb,.slides li.carouselThumb,.slides .slide');
	var iItemCount         = getSliderItemCount(oSlider, containerWidth);
	var iItemWidth         = (containerWidth) / iItemCount;
	var timeout            = oSlider.data('timeout');
	var transitionSpeed    = oSlider.data('transitionSpeed');
	var bControlNav        = (oSlider.data('controlNav') === true);
	var bDirectionNav      = (typeof oSlider.data('directionNav') !== 'undefined') ? (oSlider.data('directionNav')) : true;
	var asNavFor           = (typeof asNavFor !== 'undefined') ? asNavFor : '';
	var sAnimation         = (typeof oSlider.data('animation') !== 'undefined') ? (oSlider.data('animation')) : "slide";
	var bTouch             = (typeof oSlider.data('touch') !== 'undefined') ? (oSlider.data('touch') === true): true;
	var sDirection         = (typeof oSlider.data("direction") !== "undefined") ? oSlider.data("direction") : "horizontal";
	var borderRadius       = oSlider.data('borderRadius');
	var sDirectionNavColor = oSlider.data('directionNavColor');

	if(!isNaN(timeout)){
		timeout = timeout * 1000;
	}

	if(typeof bShowNextSlide !== "undefined" && bShowNextSlide)
	{
		iItemCount += 0.5;
	}
	if(sDirection !== "vertical")
	{
		oSlides.css({'margin-left':'0','margin-right':'12px'});
	}
	else
	{
		oSlides.css({'margin-left':'0'});
	}
	oSlider.flexslider({
		animation     : sAnimation,
		animationLoop : ((!isNaN(timeout) && timeout > 0) ? true : false),
		controlNav    : bControlNav,
		directionNav  : bDirectionNav,
		itemWidth     : iItemWidth,
		itemMargin    : (sDirection !== "vertical") ? 12 : 0,
		slideshow     : ((!isNaN(timeout) && timeout > 0 || typeof timeout === "undefined") ? true : false),
		slideshowSpeed: ((!isNaN(timeout) && timeout > 0) ? timeout : 7000),
		animationSpeed: ((!isNaN(transitionSpeed) && transitionSpeed > 0) ? transitionSpeed : 700),
		minItems      : iItemCount,
		maxItems      : iItemCount,
		asNavFor      : asNavFor,
		touch         : bTouch,
		direction     : sDirection,
		start: function(slider){
			slider.resize();
			initResponsiveImages(oSlider);
			setSliderActiveSliders(slider,oSlider,iItemCount);

			if(typeof sDirectionNavColor !== "undefined")
			{
				oSlider.find('.flex-direction-nav a').css('color',sDirectionNavColor);
			}
		},
		after: function(slider){
			setSliderActiveSliders(slider,oSlider,iItemCount);
		}
	});
}

function setSliderActiveSliders(slider,oSlider,iItemCount)
{
	oSlider.find("li").removeClass("flexSliderActiveSlides");
	var iStart = (slider.move * (slider.currentSlide));
	var iEnd = (slider.move * (slider.currentSlide + iItemCount));
	for (i = iStart + 1; i <= iEnd; i++) {
		oSlider.find("li:nth-child(" + i + ")").addClass("flexSliderActiveSlides");
	}

	if(oSlider.parents(".block").hasClass("productconfigslider"))
	{
		calcTotalAmountProductconfigslider(oSlider);
	}
}

function calcTotalAmountProductconfigslider(oSlider)
{
	var oBlock = oSlider.parents(".block");
	var oProductConfigSliders = oBlock.find(".productConfigSliders");
	var nToTal = 0;
	var sSelection = "";
	oProductConfigSliders.find(".flexslider").each(function(index, oEl)
	{
		$(oEl).find(".flexSliderActiveSlides").each(function(index,oActiveEl)
		{
			if(typeof $(oActiveEl).data("productPriceStandard") !== "undefined")
			{
				nToTal += (typeof $(oActiveEl).data("productPricePromo") !== "undefined" && parseFloat($(oActiveEl).data("productPricePromo")) != 0) ? parseFloat($(oActiveEl).data("productPricePromo")) : parseFloat($(oActiveEl).data("productPriceStandard"));
			}
			if(typeof $(oActiveEl).data("productWebname") !== "undefined")
			{
				if(sSelection == "")
				{
					sSelection += "<h3>" + oBlock.find(".productConfigSliderWrapper").data("summaryTitleText") + "</h3>"
				}
				sSelection += "<p>" + ($(oActiveEl).data("productWebname"));

				if(typeof $(oActiveEl).data("productFreetext2") !== "undefined" && $(oActiveEl).data("productFreetext2") !== "")
				{
					sSelection += "<strong>" + ($(oActiveEl).data("productFreetext2")) + "</strong></p>";
				}
				else
				{
					sSelection += "</p>";
				}
			}
		});
	});

	oBlock.find(".productConfigSelection").html(sSelection);

	if(nToTal != 0)
	{
		oBlock.find(".productConfigSliderCtaA2b").show();
		oBlock.find(".productConfigAmount").html(sCurrencySign + " " + parseFloat(nToTal).toFixed(2).replace('.',','));
	}
	else
	{
		oBlock.find(".productConfigAmount").html("");
		oBlock.find(".productConfigSliderCtaA2b").hide();
	}
}

function initResponsiveImages(oSlider){

	oSlider.find('.flex-viewport img').each(function(img){
		if(typeof $(this).data('src') !== "undefined" && $(this).data('src') !== ""){
			$(this).attr('ci-src',$(this).data('src'));
		}
	});
	$('div[ci-bg-url]').removeAttr('ci-bg-url');
	ciResponsive.process();
}

function geoLookup(sLocation, sLookupCountry, callback, sLookupCountryCode) {
	if (typeof geocoder === 'undefined' && typeof google !== 'undefined') {
		geocoder = new google.maps.Geocoder();
	}
	if (typeof geocoder !== 'undefined') {
		// Set fallback country values
		if (typeof sLookupCountry === 'undefined') sLookupCountry = sGeolookupCountryCodeDefault;
		if (typeof sLookupCountryCode === 'undefined') sLookupCountryCode = sGeolookupCountryCodeDefault;
		const locationStr = (sLocation || '').toString().trim();
		const countryDesc = (sLookupCountry || '').toString().trim().toUpperCase();
		// Build geocode request
		let geoRequest;
		// Numeric location input, assume postal code
		if (!isNaN(sLocation)) {
			geoRequest = {
				address: `${locationStr}, ${countryDesc}`,
				componentRestrictions: {
					postalCode: sLocation.trim(),
					country: sLookupCountry.trim()
				}
			};
		} else {
			// Non-numeric input, build query string
			let query = sLocation.trim();
			const hasCountry = sLocation.toLowerCase().includes(sLookupCountry.toLowerCase());
			if (!hasCountry) {
				query += ", " + sLookupCountry.trim();
			}
			geoRequest = { address: query };
		}

        geocoder.geocode(geoRequest, function (results, status) {
			const geoLookup = {
				results: Array.isArray(results) ? results : [],
				lat: (Array.isArray(results) && results.length) ? results[0].geometry.location.lat() : "",
				lng: (Array.isArray(results) && results.length) ? results[0].geometry.location.lng() : "",
				status: status,
				countryCode: sLookupCountryCode || "",
				location: sLocation
			};

			if (status === google.maps.GeocoderStatus.OK && geoLookup.lat && geoLookup.lng) {
				if (callback.name === "searchShop") {
					searchShop(sLocation, geoLookup.lat, geoLookup.lng);
				} else {
					callback(geoLookup);
				}
			} else {
				if (typeof callback === "function") callback(geoLookup);
			}
		});
    }
}


// The item counts are breakpoint-driven, so they have to agree with the CSS. documentElement
// .clientWidth is what media queries evaluate against; window.innerWidth includes the scrollbar and
// can report a stale value while a carousel is being built, which handed phone-width layouts their
// desktop item count.
function getSliderViewportWidth()
{
	return document.documentElement.clientWidth || window.innerWidth;
}

function getSliderItemCount(oSlider, containerWidth)
{
	// Opt-in: with data-item-target-width the count is derived from the available width instead of
	// being fixed, so tiles keep their designed size and the carousel simply shows more of them.
	// Without the attribute nothing changes. Only widens (never narrows) the editor's count, and
	// only above the desktop breakpoint, so the CMS setting still governs phone/tablet.
	var iTargetWidth = oSlider.data('itemTargetWidth');

	if(getSliderViewportWidth() > 1199 && typeof iTargetWidth !== 'undefined' && iTargetWidth > 0 && containerWidth > 0)
	{
		var iFixedCount   = oSlider.data('itemCountDesktop');
		var iDerivedCount = Math.max(1, Math.round(containerWidth / iTargetWidth));

		return (typeof iFixedCount !== 'undefined') ? Math.max(iFixedCount, iDerivedCount) : iDerivedCount;
	}

	var iItemCountDesktop = oSlider.data('itemCountDesktop');
	var iItemCountTabletL = oSlider.data('itemCountTabletL');
	var iItemCountTabletP = oSlider.data('itemCountTabletP');
	var iItemCountMobile  = oSlider.data('itemCountMobile');

	if(getSliderViewportWidth() > 1199 && typeof iItemCountDesktop !== 'undefined')
	{
		var iItemCount = iItemCountDesktop;
	}
	else if(getSliderViewportWidth() > 978 && getSliderViewportWidth() <= 1199 && typeof iItemCountTabletL !== 'undefined')
	{
		var iItemCount = iItemCountTabletL;
	}
	else if(getSliderViewportWidth() >= 768 && getSliderViewportWidth() <= 978 && typeof iItemCountTabletP !== 'undefined')
	{
		var iItemCount = iItemCountTabletP;
	}
	else if(getSliderViewportWidth() < 768 && typeof iItemCountMobile !== 'undefined')
	{
		var iItemCount = iItemCountMobile;
	}
	else
	{
		var oSlides    = oSlider.find('.slides li.thumb');
		var iItemCount = getSliderItemCountFallback(oSlides);
	}

	return iItemCount;
}

function getSliderItemCountFallback(oSlides)
{
	var iItemCount = 4;
	if(getSliderViewportWidth() < 768)
	{
		// Was `ItemCount`, which leaked a global and left iItemCount at 4, so any slider without a
		// data-item-count-mobile showed four tiles on a phone.
		iItemCount = 1;
	}
	else if(typeof $(oSlides) !== 'undefined')
	{
		if($(oSlides).hasClass('span4'))
		{
			if(getSliderViewportWidth() >= 768)
			{
				iItemCount = 3;
			}
			else
			{
				iItemCount = 2;
			}
		}
		else if($(oSlides).hasClass('span3'))
		{
			if(getSliderViewportWidth() > 978)
			{
				iItemCount = 4;
			}
			else if(getSliderViewportWidth() >= 768 && getSliderViewportWidth() <= 978)
			{
				iItemCount = 3;
			}
			else
			{
				iItemCount = 2;
			}
		}
		else if($(oSlides).hasClass('span2'))
		{
			if(getSliderViewportWidth() > 978)
			{
				iItemCount = 6;
			}
			else if(getSliderViewportWidth() >= 768 && getSliderViewportWidth() <= 978)
			{
				iItemCount = 3;
			}
			else
			{
				iItemCount = 2;
			}
		}
	}

	return iItemCount;
}

function getBoundingClientRect(oEl,sMetric)
{
	var rect = oEl[0].getBoundingClientRect();
	var boundingClientRectValue;

	if(sMetric === "width")
	{
		if (rect.width) {
			// `width` is available for IE9+
			boundingClientRectValue = rect.width;
		} else {
			// Calculate width for IE8 and below
			boundingClientRectValue = rect.right - rect.left;
		}
	}
	else if(sMetric === "height")
	{
		if (rect.height) {
			// `height` is available for IE9+
			boundingClientRectValue = rect.height;
		} else {
			// Calculate height for IE8 and below
			boundingClientRectValue = rect.bottom - rect.top;
		}
	}

	return boundingClientRectValue;
}

function showInfoAlert()
{
	if($("header").length > 0)
	{
		var sMessage = (adminLoggedIn) ? sMainInfoAlertEditmode : sPromptMainInfoAlertMessage;

		var typeMap   = { positive: 'success', negative: 'danger', informative: 'info', warning: 'warning', custom: 'custom' };
		var alertType = (typeof sMainInfoAlertType !== 'undefined' && typeMap[sMainInfoAlertType]) ? typeMap[sMainInfoAlertType] : 'legacy';

		var bDismissable = (typeof bMainInfoAlertDismissable === 'undefined' || bMainInfoAlertDismissable == 1);
		var sClose       = bDismissable ? '<a href="#" class="showMainInfoAlert close" data-dismiss="alert"><i class="fa far fa-times"></i></a>' : '';

		var sAlert = sClose + sMessage;
		var sClass = (alertType ? alertType + ' ' : '') + ' ' + 'main-info';

		if (adminLoggedIn)
		{
			inlineAlert(sClass + " editmodeEnabled", sAlert, false, $("#managementHeader").first());
		}
		else
		{
			inlineAlert(sClass, sAlert, false, $("header").first());
		}

		if (alertType === 'custom' && typeof sMainInfoAlertCustomConfig !== 'undefined' && sMainInfoAlertCustomConfig !== '')
		{
			var oCustom = JSON.parse(sMainInfoAlertCustomConfig);
			var $banner = $('.inlineAlert.main-info');
			if (oCustom.bg)     $banner.css('background-color', oCustom.bg);
			if (oCustom.color)  $banner.css('color', oCustom.color);
			if (oCustom.border) $banner.css('border-bottom', '1px solid ' + oCustom.border);
		}

		var $mainInfo = $('.inlineAlert.main-info');
		if ($mainInfo.length)
		{
			document.body.style.setProperty('--main-info-height', $mainInfo.outerHeight() + 'px');
		}
	}
}

function switchPriceRangePreference(oEl, sPriceRange)
{
	oEl.prop("disabled", true);

	var sParams = "&pricerange=" + sPriceRange;

	var oCall = callAjax("switchPriceRangePreference", sParams, "post", "/index.cfm/product/ajax/switchpriceRangepreference");

	// process feedback
	oCall.success(function (oData) {
		if (oData.errorType !== '')
		{
			oEl.prop("disabled", false);
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		else
		{
			location.reload();
		}
	});
}

function useBrowserLanguage(sBrowserLanguage, sActionType)
{
	$("header").removeClass("fixed");

	var sParams = "&browserLanguage=" + sBrowserLanguage +  "&actionType=" + sActionType;
	var oCall = callAjax("useBrowserLanguage", sParams, "post","/index.cfm/ajax/useBrowserLanguage");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === "")
		{
			if(sActionType === "redirect" && oData.redirectUrl !== "")
			{
				$(location).attr("href", oData.redirectUrl);
			}
			else if(sActionType === "alert" && oData.alertMessage !== "")
			{
				var sTimeout = (editMode) ? undefined : 6000;
				inlineAlert("info browserlanguage-info", oData.alertMessage, false, $("header"),false, sTimeout);

				// highlight language selector
				$(".headerLanguagesList").addClass("highlighted");
			}
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
	});
}

function loginFromId(oEl)
{

	var oLoader    = oEl.parents(".modal-body").find(".loaderWrapper");
	var oPopup    = oEl.parents(".modal");
	var customerId = oEl.data("customerId");
	var contactId = oEl.data("contactId");
	var redirectUrl = oEl.data("redirectUrl");
	var bLendingOrder = (typeof sLendoutId !== "undefined" && sLendoutId !== "");

	// If no redirectUrl in data attribute, check URL parameters
	if(!redirectUrl || redirectUrl === "")
	{
		var urlParams = new URLSearchParams(window.location.search);
		var returnUrl = urlParams.get('returnUrl');
		if(returnUrl && returnUrl !== "")
		{
			redirectUrl = returnUrl;
		}
	}

	oLoader.css("display", "flex");
	oPopup.removeClass("enabled");

	uAjax = "/index.cfm/customer/ajax/loginFromId";
	var sParams = '&customerId=' + encodeURIComponent(customerId);
	if(typeof contactId !== "undefined")
	{
		sParams += "&contactId=" + encodeURIComponent(contactId);
	}
	if(bLendingOrder)
	{
		sParams += "&lendoutId=" + encodeURIComponent(sLendoutId);
	}

	var oCall = callAjax("loginById", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType == '')
		{
			if(bLendingOrder)
			{
				$(('.formAddressWrapper.customer')).replaceWith(oData.lendoutCustomerAddress);
				$(('#deliveryAccordion')).replaceWith(oData.lendoutDeliveryAddress);
				setDeliveryDate($("#deliveryAccordion input[name='deliveryDate']"));
				$(el('returningCustomerId')).val(oData.customerId);
				lendoutStepActionProgress(3);
				$(el('lendoutFrm')).ajaxLoader('hide');

				oPopup.modal("hide");
			}
			if(typeof redirectUrl !== "undefined" && redirectUrl !== "")
			{
				window.location = redirectUrl;
			}
			else if(sChannel === 'B2B')
			{
				window.location = "/" + sCurrentLanguageCode + ((typeof sPostLoginFromIdUrl !== "undefined") ? sPostLoginFromIdUrl : "/product/customer");
			}
			else
			{
				// B2C used to land on the basket unconditionally. This is the step that completes a
				// login for a customer with several contacts, so that customer never reached the rule
				// the single-contact path applies (ECOMMA-4094): the basket only when it holds
				// something, otherwise the homepage. loginFromId reports basketFilled for that.
				window.location = oData.basketFilled
					? "/" + sCurrentLanguageCode + "/transaction"
					: "/" + sCurrentLanguageCode + "/";
			}
		}
		else if(oData.errorType === 'classification')
		{
			oLoader.hide();
			oPopup.addClass("enabled");

			clearErrors();
			if($('#webshops').length == 0)
			{
				$('body').append(oData.html);
			}
			else
			{
				$('#webshops').replaceWith(oData.html);
			}

			$('#webshops').modal();
			centerPopups();
		}
		else
		{
			oLoader.hide();
			oPopup.addClass("enabled");

			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

(function($) {
	$.event.special.doubletap = {
		bindType: 'touchend',
		delegateType: 'touchend',
		handle: function(event) {
			var handleObj = event.handleObj,
				targetData = jQuery.data(event.target),
				now = new Date().getTime(),
				delta = targetData.lastTouch ? now - targetData.lastTouch : 0,
				delay = delay == null ? 300 : delay;
			if (delta < delay && delta > 30) {
				targetData.lastTouch = null;
				event.type = handleObj.origType;
				['clientX', 'clientY', 'pageX', 'pageY'].forEach(function(property) {
					event[property] = event.originalEvent.changedTouches[0][property];
				})
				handleObj.handler.apply(this, arguments);
			} else {
				targetData.lastTouch = now;
			}
		}
	};
})(jQuery);

(function($) {
	$.fn.center = function() {
		this.css("position", "absolute");
		this.css("top", Math.max(0, (($(window).height() - $(this).outerHeight()) / 2 - 200) +
			$(window).scrollTop()) + "px");
		return this;
	}
})(jQuery);

function initExternalAuthorization()
{
	oCall = easAuthorize();
	oCall.success(function(oData)
	{
		if (oData.errorMessage === "" && oData.value !== "")
		{
			$(el("btnExternalAuthorizationGlobal")).prop('disabled',false).data("auth-url",oData.value);

			if($(".btnExternalAuthorizationGlobal").length > 0)
			{
				$(".btnExternalAuthorizationGlobal").prop('disabled',false).data("auth-url",oData.value);
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function easAuthorize()
{
	return callAjax("easAuthorize", "", "post", "/index.cfm/customer/ajax/easAuthorize");
}

$(function () {

	centerPopups();
	initLazyResponsiveLoad();

	$('.waylf').click(function() {
		$(this).hide();
		$('.searchfield').show();
	});
	$('.alertContainer').delegate('.popupAlert', 'click', function() {
		$(this).alert('close');
	});

	var otextSlide = document.querySelector(".slider-usp");
	if(otextSlide){
		var text = otextSlide.querySelectorAll("li");

		var counter = 1;

		//get the text elemenet with the biggest height
		var size = 0;
		text.forEach((el) => {
			if(el.clientHeight > size){
				size = el.clientHeight;
			}
		});

		//set css on vanilla js element
		text.forEach((el) => {
			el.style.height = size + 'px';
			el.style.display = 'flex';
			el.style.alignItems = 'center';
			el.style.justifyContent = 'center';
		});

		otextSlide.style.height = size + 'px';
		otextSlide.style.transform = `translateY(-${size * counter}px)`;
		setInterval(()=>{
			if(counter >= text.length -1) return;
			otextSlide.style.transition = `transform 0.8s ease`;
			counter++;
			otextSlide.style.transform = `translateY(-${size * counter}px)`;
		}, 4000);
		otextSlide.addEventListener('transitionend', () => {
		if(text[counter].id === 'lastClone'){
			otextSlide.style.transition = `none`;
			counter = text.length - 2;
			otextSlide.style.transform = `translateY(-${size * counter}px)`;
		}
		if(text[counter].id === 'firstClone'){
			otextSlide.style.transition = `none`;
			counter = text.length - counter;
			otextSlide.style.transform = `translateY(-${size * counter}px)`;
		}
		});
	}

	var oSearchInput = $('header input[name="keyword"]');
	oSearchInput.on('blur', function(e)
	{
		setTimeout(function()
		{
			if(!bSuggestClicked && $('.jsHeaderSearch').length == 0)
			{
				$(el('suggest')).remove();
			}
			if(!bToggleClearSearchFieldClicked)
			{
				$('.toggleClearSearchField').remove();
			}
		},1);
	});

	$(el('mainContainer')).on('mousedown', '#suggest li', function(e) {
		bSuggestClicked=true;
	});

	$(el('mainContainer')).on('mouseup', '#suggest li', function(e) {
		bSuggestClicked=false;
	});

	$(el('mainContainer')).on('mousedown', '.toggleClearSearchField', function(e) {
		bToggleClearSearchFieldClicked=true;
	});

	$(el('mainContainer')).on('mouseup', '.toggleClearSearchField', function(e) {
		bToggleClearSearchFieldClicked=false;
	});

	oSearchInput.on('keyup', function(e)
	{
		var button = $(this);
		clearTimeout(typingTimer);
		typingTimer = setTimeout(function () {
			doneTyping(button, e);
		}, doneTypingInterval);
	});
	oSearchInput.on('keydown', function (e) {
		clearTimeout(typingTimer);
	});


	if($('.useToggleClearSearchFieldContainer').length > 0)
	{
		oSearchInput.on('mouseup keyup', function(e)
		{
			if($('.toggleClearSearchField').length == 0 && $(this).val() !== "")
			{
				$("<span class='toggleClearSearchField'><i class='icon-remove fa fa-times'></i></span>").insertAfter($(this));
			}
			else if($('.toggleClearSearchField').length == 1 && $(this).val() === "")
			{
				$('.toggleClearSearchField').remove();
			}
		});
	}

	$(el('mainContainer')).on('click','.toggleClearSearchField', function(event)
	{
		oSearchInput.val("");
		$(this).remove();
	});

	if(typeof sSearch !== 'undefined' && sSearch !=='')
	{
		oSearchInput.val(sSearch);
	}


	if($('.pinContainer').length > 0 || $('.pinElement').length > 0)
	{
		var iOffsetTop     = (typeof $(".pinElement").data("pin-offset") !== "undefined") ? $(".pinElement").data("pin-offset") : 92;
		var bMobileScreen  = ($(window).width() <= 768);
		var bDesktopScreen = ($(window).width() > 768);
		var bPinMobile     = true;
		var bPinDesktop    = true;

		if(typeof $(".pinElement").data("pin-mobile") !== "undefined")
		{
			bPinMobile = $(".pinElement").data("pin-mobile");
		}
		if(typeof $(".pinElement").data("pin-desktop") !== "undefined")
		{
			bPinDesktop = $(".pinElement").data("pin-desktop");
		}

		if(bMobileScreen && bPinMobile || bDesktopScreen && bPinDesktop)
		{
			$(".pinElement").onClassChange((el, newClass) => {
				if (newClass.indexOf("pinActive") >=0) {
					$('.pinContainer').addClass("pinnedElementParent");
				} else {
					$('.pinContainer').removeClass("pinnedElementParent");
				}
			});
			if($('.pinContainer').length > 0)
			{
				$('.pinElement').pin({containerSelector: ".pinContainer",padding: {top: iOffsetTop}, activeClass: 'pinActive'});
			}
			else
			{
				$('.pinElement').pin({padding: {top: iOffsetTop}, activeClass: 'pinActive'});
			}
		}
	}

	if($('.useToggleClearSearchFieldContainer').length > 0 && $('.toggleClearSearchFieldContainer').length == 0)
	{
		var sMarginBottom = oSearchInput.css("marginBottom");
		var sWidth        = ( 100 * parseFloat(oSearchInput.css("width")) / parseFloat(oSearchInput.parent().css('width')) ) + '%';
		oSearchInput.wrap('<div class="toggleClearSearchFieldContainer"></div>');
		oSearchInput.css("marginBottom", '0');
		oSearchInput.outerWidth("100%");
		$('.toggleClearSearchFieldContainer').css("marginBottom",sMarginBottom);
		$('.toggleClearSearchFieldContainer').width(sWidth);
	}

	$(el('mainContainer')).on('click', '.suggestTerm', function()
	{
		var oForm  = $(el('suggest')).parents('form');

		oSearchInput.val($(this).text().trim());
		oForm.submit();
	});

	$('#btnSubscribe').on('click', function() {
		subscribe($('#frmSubscribe'));
		return false;
	});

	$(el('frmSubscribe')).on('submit', function(e)
	{
		e.preventDefault();

		subscribe($(el('frmSubscribe')));
	});

	if($(window).width() > 767 && $('.jsDropdownSubmenu').length == 0 && (Modernizr.touch || !!(window.navigator.msMaxTouchPoints) || isTouchDevice() || isKiosk))
	{
		var oRootListItems = $('.navbar .nav-collapse > .menuItem > ul > li > a,.navbar .nav-collapse > .visible-desktop > .menuItem > ul > li > a,.navbar .level1');

		oRootListItems.on("click touchend", function(e) {
			if ($(this).parent().find('div:first').length) {
				e.preventDefault();

				var oListItem = $(this).parent();

				if (!$(e.target).is('.level1'))
				{
					oRootListItems.parent().find('div:first').hide();
					oRootListItems.parent().removeClass('touched');
				}

				oListItem.addClass('touched');
				oListItem.find('div:first').show();
			} else {
				var linkUrl = $(this).prop('href');
				window.location = linkUrl;
				event.preventDefault();
			}
			return false;
		});
		$('.navbar li .level1, .navbar li .dropdown-toggle').on('doubletap', function(event) {
			var linkUrl = $(this).prop('href');
			window.location = linkUrl;
			event.preventDefault();
			return false;
		});
		$(document).on('click touchstart', function(e) {
			if (!$(e.target).is('.level1') && !$(e.target).is('.navbar .nav-collapse > .menuItem > ul > li a') && !$(e.target).is('.navbar .nav-collapse > .visible-desktop > .menuItem > ul > li a')) {
				oRootListItems.parent().find('div:first').hide();
				oRootListItems.parent().removeClass('touched');
			}
		});

	} else {
		if ($(window).width() > 768) {
			$('.menuItemLink[data-toggle="dropdown"]').click(function(e) {
				e.preventDefault();

				var linkUrl = $(this).prop('href');
				window.location = linkUrl;
			});
		}
	}
	$('#menuPhone').change(function() {
		var menuLink = $(this).val();
		window.location = menuLink;
	});

	if (editMode)
	{
		initButtons();

		// reset opacity to prevent layout glitches
		$('.editTranslationWrapper').parents().css('opacity','1');

		// Show edit button
		$('#mainContainer').on({
			mouseenter: function() {
				$(this).find('.doEdit').show();
			},
			mouseleave: function() {
				$(this).find('.doEdit').hide();
			}
		}, '.editTranslation');

		$('#mainContainer').on('click', 'a', function(e)
		{
			var oManagementHeader = document.getElementById('managementHeader');

			if(!oManagementHeader.contains(e.target))
			{
				e.preventDefault();
			}
		});

		// Edit translation
		$('#mainContainer').on('click', '.editTranslation', function(e)
		{
			e.preventDefault();
			e.stopPropagation();
			editTranslation($(this));
		});

		// Any control whose label carries an editable translation must not act while
		// the translation editor is on (product facets, checkbox filters, ...).
		// preventDefault: labels activate their control as the click's default action.
		// stopImmediatePropagation: kills JS-driven handlers (updateFilter on change,
		// the radio re-click toggle in modules/product/scripts/js/list.js).
		$('#mainContainer').on('click change', 'label, input, select', function(e)
		{
			var oLabel = $(e.target).closest('label');

			if (oLabel.length && oLabel.find('.editTranslationWrapper').length)
			{
				e.preventDefault();
				e.stopImmediatePropagation();
			}
		});

		// Update translation
		$('#mainContainer').on('change keyup paste', '.translationText', function() {
			var element = $(this).closest('.popover').prev();
			if (element.children().length > 0) {
				element.find('.editTranslation').text($(this).val());
			} else {
				element.text($(this).val());
			}

		});

		// Save translation
		$('#mainContainer').on('click', '.btnEditTranslation', function(e) {
			saveTranslation($(this));
			return false;
		});

		$('#mainContainer').on('click', '.btnCancelEditTranslation', function()
		{
			$(this).parents('.popover').prev().popover('hide');
		});
	}
	// Show popup when parameter is specified
	if (sPopupType !== '' && sPopupType !== 'undefined') {
		showCustomerPopup(sPopupType);
	}

	if (editModeContent || (typeof bLinkedContentWishlist !== 'undefined' && bLinkedContentWishlist)) {
		$('#mainContainer').on('click','.changeContentPage', function() {
			changeContentPage($(this).data('page'));
		});

		$('#mainContainer').on('click','.removeContentPage', function() {
			var page = $(this).data('page');
			setLinkedPage(page, '', $(this));
		});

		// Filter pages
		$('#mainContainer').on('keyup', '.contentManagement .filter', function() {

			var keyword = $(this).val();
			if (keyword === '') {
				$(el('pickPages')).find('tbody tr').show();
			} else {
				$(el('pickPages')).find('tbody tr').each(function() {
					var name = $(this).data('name');
					if (name.indexOf(keyword) < 0) {
						$(this).hide();
					} else {
						$(this).show();
					}
				});
			}
		});

		// Pick page
		$('#mainContainer').on('click', '.contentManagement .btnPick', function() {

			var page = $(this).data('page');
			var name = $(this).data('name');
			setLinkedPage(page, name, $(this));
		});
	}

	if ($(el('backToTop')).length) {
		var oBtn = $(el('backToTop'));
		if ($(el('whatsappChatButton')).length) {
			oBtn.show().css('margin-right','-500px'); // Temporarily show back to top button to calculate its height for the offset (negative margin to avoid flicker)
			var nBackToTopOffset = parseInt(oBtn.css('bottom').replace('px',''));
			$(el('whatsappChatButton')).css('bottom',(nBackToTopOffset + 50) + 'px')
			oBtn.hide().css('margin-right','');
		}

		$(window).scroll(function () {
			if ($(this).scrollTop() > 150) {
				oBtn.fadeIn();
			} else {
				oBtn.fadeOut();
			}
		});
		// scroll body to 0px on click
		oBtn.on('click', function() {
			$('body,html').animate({
				scrollTop: 0
			}, 800);
			return false;
		});
	}

	$('#mainContainer').on('click', '.searchInputToggle', function(evt) {
		evt.preventDefault();

		$(el('appendedInputButton')).animate({
			width: 'toggle'
		}, 350);
	});

	// Hover color
	$('.menuList').hover(function() {
		if ($(this).data('colour') !== '') {
			$(this).find('li:first-child a:first').css('color', $(this).data('colour'));
		}
	}, function() {
		$(this).find('li:first-child a:first').css('color', '');
	});

	$('.cookies .close').on('click',function(){
		closeCookiePopup($(this));
	});

	$('#mainContainer').on('click', '.main-info .close', function(){
		$(".nav-collapse.fsMenu, .faMenulink.min, .dontDisplayMenuLink>.menuItem").css("margin-top", 0);
	});

	//onclick for buttons mobile navigation on i tag
	$(el('mainContainer')).on('click', '.faMenulink', function(e) {

		if(!$(e.target).hasClass('directLink'))
		{
			//Function to display or hide the subitems of the menu
			var idOfDiv = $(this).attr("data-id");
			var currentId = document.getElementById('menu'+idOfDiv);

			if($(currentId).is(":visible") == false){
				// Opening never closed the sibling that was already open, so a second level-1 item
				// unfolded under the first one and its fixed header stayed on screen above it.
				// Only menus that ask for it (.menuAccordion) behave this way.
				$(this).closest('.menuItem.menuAccordion').children('.menuList').find('> li > .dontDisplayMenuLink:visible').each(function () {
					var sOpenId = $(this).attr('id').replace(/^menu/, '');
					$(this).hide();
					$('#iPlusOf' + sOpenId).show();
					$('#iMinOf' + sOpenId).hide();
				});
				$(currentId).show();
				$('#iPlusOf'+idOfDiv).hide();
				$('#iMinOf'+idOfDiv).show();
			} else {
				$(currentId).hide();
				$('#iPlusOf'+idOfDiv).show();
				$('#iMinOf'+idOfDiv).hide();
			}
		}
	});

	if($('.nav-horizontal').length)
	{
		var bMovingRight   = false;
		var oCurrentTarget = null;
		var xPrev          = 0;

		$(el('mainContainer')).on('mousemove mouseleave mouseenter', '.visible-desktop .menuList  li', function(e)
		{
			if(e.type == "mouseenter")
			{
				if(!bMovingRight)
				{
					oCurrentTarget = e.currentTarget;
					$(e.currentTarget).find(">.menuItem").show();
				}
				else
				{
					setTimeout(function ()
					{
						if(!bMovingRight || oCurrentTarget == null)
						{
							oCurrentTarget = e.currentTarget;
							$(e.currentTarget).find(">.menuItem").show();
						}
					}, 510);
				}
			}

			if(e.type == "mousemove")
			{
				if(xPrev<e.pageX)
				{
					bMovingRight = true;
					if(oCurrentTarget != e.currentTarget)
					{
						var hideTimer = setTimeout(function ()
						{
							if(oCurrentTarget != e.currentTarget)
							{
								bMovingRight = false;
								oCurrentTarget = null;
								hideTimer = null;
							}
						}, 500);
					}
				}
				else
				{
					bMovingRight = false;
					clearTimeout(hideTimer);
				}
				xPrev=e.pageX;
			}

			if(e.type == "mouseleave")
			{
				if(!bMovingRight && oCurrentTarget != e.currentTarget)
				{
					$(e.currentTarget).find('>.menuItem').hide();
				}
				else
				{
					setTimeout(function ()
					{
						if(!bMovingRight || oCurrentTarget == null && oCurrentTarget != e.currentTarget)
						{
							$(e.currentTarget).find('>.menuItem').hide();
						}
					}, 505);
				}
			}
		});
	}

	if($('.menuToggleContainer.isNotHomePage').length)
	{
		$('#mainContainer').on('click', '.menuToggleContainer', function(evt) {
			if($(this).hasClass('open'))
			{
				$(this).addClass('closed');
				$(this).removeClass('open');
				$(this).parents('.navbarInner').find('.collapse').hide();
			}
			else
			{
				$(this).addClass('open');
				$(this).removeClass('closed');
				$(this).parents('.navbarInner').find('.collapse').show();
			}
		});
	}

	$(el('mainContainer')).on('click', '#askQuestion', function()
	{
		if(validateForm($(el('popupQuestion'))))
		{
			var sParams = getValues($(el('popupQuestion')));

			var oCall = callAjax("sendQuestion", sParams, "post", "/index.cfm/ajax/sendQuestion");
			// process feedback
			oCall.success(function(oData) {
				if (oData.errorType === '')
				{
					$(el('popupQuestion')).modal('hide');
				}
				else {
					// show error message
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	$(el('mainContainer')).on('click', '#submitSimpleForm', function()
	{
		if(validateForm($(el('popupSimpleForm'))))
		{
			var oValueLabels = getValueLabels($(el('popupSimpleForm')));

			var oCall = callAjax("submitSimpleForm", oValueLabels, "post", "/index.cfm/ajax/submitSimpleForm");
			oCall.success(function(oData)
			{
				if (oData.errorType == '')
				{
					$(el('popupSimpleForm')).modal('hide');
				}
				else
				{
					// show error message
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	$(el('mainContainer')).on('click', '#suggest .suggestLine', function(event)
	{
		event.preventDefault();
		var linkUrl     = $(this).find('.colourURL').prop('href');
		window.location = linkUrl;

		return false;
	});

	// Add to basket from thumb
	$(el('mainContainer')).on('click','.btn[data-add="basket"]',function(e)
	{
		e.preventDefault();

		var iQty = $(this).closest('li').find('.thumbQtyInput').val();
		addProductToBasket($(this), iQty);
		return false;
	});

	// show popu with proposed URL
	if(sProposedUrl !== '')
	{
		clearErrors();
		$('#switchwebshop #btnContinueCountryShop').prop('href','https://' + sProposedUrl);
		var sText = $('#switchwebshop .modal-body .text').text();
		sText = sText.replace('${country}',sCountry).replace('${url}','<b>' + sProposedUrl.replace('https://','') + '</b>');
		$('#switchwebshop .modal-body .text').html(sText);

		sText = $('#switchwebshop #btnContinueCountryShop').text();
		sText = sText.replace('${url}',sProposedUrl.replace('https://',''));
		$('#switchwebshop #btnContinueCountryShop').text(sText);

		$('#switchwebshop').modal();
		centerPopups();
	}

	$(el('mainContainer')).on('click', '.btn-navbar.fsMenu', function () {
		loadMobileNavigation();
	});

	$(el('mainContainer')).on('show','.nav-collapse.fsMenu', function()
	{
		$('html, body').animate({ scrollTop: 0 }, 0);
		$('html, body').css({'overflow':'hidden', 'position': 'relative', 'height':'100%'});

		if ($('#mainContainer').find('.main-info').length > 0) {
			var iMainInfoHeight = $(".main-info").outerHeight() + "px";
			if ($(".faMenulink.min").css("position") == "fixed") {
				$(".nav-collapse.fsMenu, .faMenulink.min, .dontDisplayMenuLink>.menuItem").css("margin-top", iMainInfoHeight);
				if (!$(".nav-collapse.fsMenu").hasClass("mainInfoSizeGap")) {
					$(".nav-collapse.fsMenu").addClass("mainInfoSizeGap");
				}
			} else {
				$(".nav-collapse.fsMenu").css("margin-top", iMainInfoHeight);
			}
		}
	});

	$(el('mainContainer')).on('hide','.nav-collapse.fsMenu', function()
	{
		$('html, body').css({'overflow':'visible', 'position': 'static', 'height':'auto'});
		if ($('#mainContainer').find('.main-info').length > 0) {
			$(".nav-collapse.fsMenu, .faMenulink.min, .dontDisplayMenuLink>.menuItem").css("margin-top", 0);
		}
	});


	$(el('mainContainer')).on('change', '#addProductWishlistPopup #wishlistsDropdown', function(e)
	{
		var oSelectBtn = $('#addProductWishlistPopup').find(".selectBtn");
		oSelectBtn.prop('disabled',false);
	});


	$(el('mainContainer')).on('click', '#addProductWishlistPopup .selectBtn', function(e)
	{
		e.preventDefault();
		addToWishlistList($(this))
	});

	$(el('mainContainer')).on('click','.btnRemoveWishlist', function(e){
		e.preventDefault();
		if (bEnableNewWishlist) {
			$(this).prop('disabled',true);
			deleteFromWishlist($(this));
		} else {
			removeFromwishlist($(this).data('productId'));
		}

	});

	$(el('mainContainer')).on('click','.btnAddWishlist', function(e)
	{
		e.preventDefault();
		if (bEnableNewWishlist) {
			$(this).prop('disabled',true);
			var sProductId = $(this).closest('li').data('product');
			var oThumb = $('.thumb[data-product="' + sProductId + '"]');
			var selectedSizeSkuId = oThumb.find('.selectedSkuId').attr('data-skuid');
			if ((oThumb.find(".thumbSizeItem").length > 1 || oThumb.find(".swatch").length > 1) && typeof selectedSizeSkuId === "undefined") {
				window.location = $(this).attr('href');
			} else {
				addToWishlistPopup($(this), sProductId);
			}
		} else {
			addToWishlist($(this).data('productId'));
		}
	});

	// Swatch click product thumbs
	$(el('mainContainer')).on('click','.swatch',function(){
		selectSwatch($(this));
	});

	$(document).on('lazyloaded', function(e)
	{
		// Reset placeholderBackground when loaded
		if($(e.target.parentNode).hasClass('ci-image-wrapper'))
		{
			$(e.target.parentNode).css('background','transparent');
		}
	});

	$(el('mainContainer')).on('click','.sendPicturePack',function(oEvent){
		oEvent.preventDefault();
		popupSendPicturePack($(this).data('skuIds'),$(this));
		return false;
	});

	$('body').on('click','#sendConfirmPicturePackModal #btnSend',function(oEvent){
		oEvent.preventDefault();
		$(this).prop('disabled',true);

		sendPicturePack($(this).data('skuIds'),$(this));
		return false;
	});

	$('body').on('shown','.customerPopup', function(event)
	{
		ciResponsive.process();
	});

	if(typeof bUseBrowserLanguage !== "undefined" && bUseBrowserLanguage && typeof sUseBrowserLanguageActionType !== 'undefined' && sUseBrowserLanguageActionType !== "")
	{
		if((sUseBrowserLanguageActionType === "alert" || sUseBrowserLanguageActionType === "redirect") && document.cookie.indexOf("USEBROWSERLANGUAGE")  === -1)
		{
			var sBrowserLanguage = detectBrowserLanguage();
			useBrowserLanguage(sBrowserLanguage,sUseBrowserLanguageActionType);
		}
	}

	if (typeof sContentPagePromptPopupCookieCheck !== 'undefined' && sContentPagePromptPopupCookieCheck !== '') {
		showContentPopup(sContentPagePromptPopupCookieCheck);
	}

	if (typeof bShowIdleBasketPopup !== 'undefined' && bShowIdleBasketPopup) {
		showIdleBasketPopup();
	}

	if (typeof bPromptMainInfoAlert !== 'undefined' && bPromptMainInfoAlert == 1 && typeof sPromptMainInfoAlertKey !== "undefined" && typeof sPromptMainInfoAlertMessage !== "undefined")
	{
		showInfoAlert();

		$(el('mainContainer')).on('click','.showMainInfoAlert.close',function(e)
		{
			setCookie("mainInfoAlertSeen",sPromptMainInfoAlertKey,30);
			document.body.style.setProperty('--main-info-height', '0px');
		});
	}

	$(el('mainContainer')).on('click','.scanMode',function(e)
	{
		e.preventDefault();

		setScanMode($(this));
		return false;
	});

	$(el('mainContainer')).on('submit', '.siteSearch.scanmode', function(e)
	{
		e.preventDefault();

		var sBarCode = $(this).find('input').val();

		if(typeof sBarCode !== 'undefined' && sBarCode !== '')
		{
			scanBarCode(sBarCode);
		}
	});

	if($('.siteSearch.scanmode').length > 0)
	{
		oSearchInput.focus();
		oSearchInput.off("keyup keydown");
	}

	if(Modernizr.touch || !!(window.navigator.msMaxTouchPoints) || isTouchDevice())
	{
		$('body').addClass('isTouchDevice');
	}

	$(el('mainContainer')).on("click", '.jsDropdownSubmenu', function(e)
	{
		$('.jsDropdownSubmenuWrapper').find('.jsDropdownMenu').hide();

		if($(this).hasClass('activeJsDropdownSubmenu'))
		{
			$(this).removeClass('activeJsDropdownSubmenu');
		}
		else
		{
			$('.jsDropdownSubmenu').removeClass('activeJsDropdownSubmenu');
			$(this).addClass('activeJsDropdownSubmenu');
		}

		$(this).next('ul').toggle();
		e.stopPropagation();
		e.preventDefault();
	});

	$(el('mainContainer')).on('change', '.cartDropdownProductLineQuantity', function()
	{
		var iQty        = $(this).val();
		var iMultiplier = $(this).data('qtyMultiplier');
		var iStock      = parseInt($(this).data('stock'));
		var sLineId     = $(this).attr("line-id");

		if(iQty == 0){
			removeLine(sLineId);
		}
		else
		{
			validateBasketDropdownProductLineQuantity(iQty,iMultiplier,iStock,sLineId);
		}
	});

	$(el('mainContainer')).on('click', '.cartDropdownProductLineQuantityBtn', function(e) {
		e.preventDefault();

		var oEdtQty    = $(this).parents('.lineQty').find('.cartDropdownProductLineQuantity');

		var iCurrentVal = parseInt(oEdtQty.val());
		var iMultiplier = parseInt(oEdtQty.data('qtyMultiplier'));
		var sType      = $(this).attr('data-type');

		if (!isNaN(iCurrentVal))
		{
			if(sType === 'minus')
			{
				if(iCurrentVal > 0)
				{
					oEdtQty.val(iCurrentVal - (1*iMultiplier)).change();
				}
			}
			else if(sType === 'plus')
			{
				oEdtQty.val(iCurrentVal + (1*iMultiplier)).change();
			}
		}
	});

	$(el('mainContainer')).on("focus", '.jsHeaderSearch input', function(e)
	{
		e.preventDefault();

		handleTriggerJsHeaderSearch($(this));
	});

	$(el('mainContainer')).on("click", '.dismissJsHeaderSearch', function(e)
	{
		e.preventDefault();

		handleDismissJsHeaderSearch($(this));
	});

	$(el('mainContainer')).on("click", '.submitJsHeaderSearch', function(e)
	{
		e.preventDefault();

		$(".jsHeaderSearch").submit();
	});

	$(el('mainContainer')).on('keyup', '.maxCharsTextAreaWrapper textarea', function()
	{
		var iMaxChars = (typeof $(this).data("maxChars") !== "undefined" && !isNaN($(this).data("maxChars"))) ? parseInt($(this).data("maxChars")) : 999;
		$(this).val($(this).val().substring(0,iMaxChars));

		var charCount = parseInt($(this).val().length);
		$(this).parents(".maxCharsTextAreaWrapper").find('.charCount').html(charCount);
	});

	$(el('mainContainer')).on('keyup', '.maxCharsField', function()
	{
		var iMaxChars = (typeof $(this).data("maxChars") !== "undefined" && !isNaN($(this).data("maxChars"))) ? parseInt($(this).data("maxChars")) : 999;
		$(this).val($(this).val().substring(0,iMaxChars));
	});

	// fix collapse class (bootstrap bug)
	$('#footerAccordion .accordion-body').on('hide', function () {
		$(this).parents('.accordion-group').find('.accordion-toggle a[data-toggle="collapse"]').addClass('collapsed');
	});

	$(el('mainContainer')).on('show', '.productPaymentModal', function()
	{
		centerPopups();
	});

	$(el('mainContainer')).on('click', '#managementHeader #createQrCodeForPage', function()
	{
		$(el("createQrCodeForPage")).prop("disabled",true);

		createQrCode();
	});

	$(el('mainContainer')).on('change', '.toggleCheckBoxesByContainer', function()
	{
		var sSelectionContainer = $(this).data("selectionContainer");
		var bChecked = $(this).prop("checked");

		if($('#'+ sSelectionContainer).length > 0) // check by id
		{
			$('#'+ sSelectionContainer).find('input[type=checkbox]:not(.toggleCheckBoxesByContainer)').prop("checked",bChecked).trigger("change");
		}
		else if($('.'+ sSelectionContainer).length > 0) // check by class
		{
			$('.'+ sSelectionContainer).find('input[type=checkbox]:not(.toggleCheckBoxesByContainer)').prop("checked",bChecked).trigger("change");
		}
	});

	$(el('mainContainer')).on('click','.copiable', function(e) {

		var copyContent = $('.copiable').data().copyContent;
		var dialogContent = $('.copiable').data().dialogContent;
		navigator.clipboard.writeText(copyContent);
		var iFadeDelay = 1000;
		var fadeDuration = 1000;
		var topOffset  = $(".copiable").offset().top + 20;
		var leftOffset = $(".copiable").offset().left - 140;
		var oDiv = $('<div class="copiedToClipboardWrapper">')
			.css({
				"left": leftOffset + 'px',
				"top":  topOffset  + 'px'
			})
			.append($('<span class="clipboardMessage">' + dialogContent + '</span>'))
			.appendTo(document.body);

		setTimeout(function() {
			oDiv.addClass('fade-out');
			setTimeout(function() { oDiv.remove(); }, fadeDuration);
		}, iFadeDelay);
	});

	$(el('mainContainer')).on('click','.sliderClickHandler', function(e) {
		let imageIndex              = e.currentTarget.dataset.sliderCounter;
		let colorID                 = e.currentTarget.dataset.colourId;
		moveSlider(imageIndex, colorID);
	 });

	 $(el('mainContainer')).on('click','.move_up', function(e) {
		let colorId = e.currentTarget.dataset.colourId;
		if(selectedImageIndex < $(`ul#verticalSlider_${colorId} li`).length)
			moveSlider(selectedImageIndex + 1, colorId)
	});

	$(el('mainContainer')).on('click','.move_down', function(e) {
		let colorId = e.currentTarget.dataset.colourId;
		if(selectedImageIndex > 1)
			moveSlider(selectedImageIndex - 1, colorId)
	});

	$(el('mainContainer')).on("shown", ".addSkuPopup", function (e)
	{
		ciResponsive.process();

		var oSlider = $('.addSkuPopup .flexslider');
		if(oSlider.length > 0)
		{
			oSlider.each(function(index, oEl)
			{
				if($(oEl).hasClass('responsive'))
				{
					var iInnerWidth = $(oEl).innerWidth();
					setSlider($(oEl), iInnerWidth);

					setTimeout(function () {
						centerPopups();
					}, 1000);
				}
			});
		}
	});
	$(el('mainContainer')).on("shown", ".addSkuPopupMobile", function (e)
	{
		ciResponsive.process();

		var oSlider = $('.addSkuPopupMobile .flexslider');
		if(oSlider.length > 0)
		{
			oSlider.each(function(index, oEl)
			{
				if($(oEl).hasClass('responsive'))
				{
					var iInnerWidth = $(oEl).innerWidth();
					setSlider($(oEl), iInnerWidth);

					setTimeout(function () {
						centerPopups();
					}, 1000);
				}
			});
		}
	});

	if($('header.fixed').length && adminLoggedIn != 1 && editModeContent != 1)
	{
		var retriesLeft = 2;
		var validateFixedActiveClass = function()
		{
			var oFixedHeader                    = $('header.fixed');
			var oFixedHeaderCloneFixedActive    = oFixedHeader.clone();
			var oFixedHeaderCloneFixedNotActive = oFixedHeader.clone();
			var iMainInfoHeight 				= 0;

			oFixedHeaderCloneFixedActive.addClass('fixedActive fixedHeaderClone').css({left: "-10000px"}).appendTo("body");

			if(oFixedHeaderCloneFixedActive.css('position').toLowerCase() == "fixed")
			{
				// theme allstyles.css is loaded
				oFixedHeaderCloneFixedActive.css({position: "absolute"});
				oFixedHeaderCloneFixedNotActive.addClass('fixedHeaderClone').removeClass('fixedActive in').css({position: "absolute",left: "-10000px"}).appendTo("body");

				if ($('#mainContainer').find('.main-info').length > 0) {
					iMainInfoHeight = $(".main-info").outerHeight();
				}
				var iTopDistance = oFixedHeaderCloneFixedNotActive.outerHeight(true) - oFixedHeaderCloneFixedActive.outerHeight(true) + iMainInfoHeight;
				$('<div class="topSpacer"></div>').insertBefore(oFixedHeader);
				$('.topSpacer').css('height', oFixedHeaderCloneFixedNotActive.outerHeight(true) + 'px').hide();
				$('.fixedHeaderClone').remove();

				$(document).scroll(function()
				{
					if ($(this).scrollTop() >= iTopDistance)
					{
						var iDocumentHeight = $(document).innerHeight();
						var iWindowHeight   = $(window).innerHeight();

						if((iDocumentHeight - iTopDistance*2) >= iWindowHeight)
						{
							// The spacer stands in for the header once it leaves the flow, so it has to be
							// exactly as tall as the header is right now. The init-time value was measured
							// on a clone parked on <body>, which lays out at a different width and so a
							// different height; that difference shrank the document the moment the header
							// went fixed, moving everything under it (and, on a short page, the scroll
							// position with it). Measure on the way in only, while it is still in flow.
							if(!oFixedHeader.hasClass('fixedActive'))
							{
								$('.topSpacer').css('height', oFixedHeader.outerHeight(true) + 'px');
							}
							// Swap the header out of the flow and the spacer into it in the SAME layout pass.
							// Reading a computed style in between (the position check used to sit here) flushes
							// layout, so the browser sees two separate height changes above the scroll position
							// instead of one that nets to zero. Only the second gets compensated: a computed
							// `position` change suppresses scroll anchoring, a `display` change does not, so the
							// page was pushed down by exactly the spacer height. .show()/.hide() read the computed
							// display and flush too, hence .css().
							$('.topSpacer').css('display', 'block');
							oFixedHeader.addClass('in fixedActive');
							if(oFixedHeader.css('position') !== 'fixed')
							{
								oFixedHeader.removeClass('in fixedActive');
								$('.topSpacer').css('display', 'none');
							}
							if(oFixedHeader.find('#suggest').length > 0)
							{
								$(el('suggest')).remove();
							}
						}
					}
					else
					{
						// Paired in one layout pass on the way back up too, same reason as above.
						oFixedHeader.removeClass('in fixedActive');
						$('.topSpacer').css('display', 'none');
					}
				});
			}
			else if(retriesLeft > 0)
			{
				retriesLeft--;
				$('.fixedHeaderClone').remove();
				setTimeout(validateFixedActiveClass, 1000);
			}
			else
			{
				$('.fixedHeaderClone').remove();
			}
		}
		validateFixedActiveClass();
	}
	if(bSetcontact)
	{
		uAjax = "/index.cfm/ajax/loadcontacts";
		var oCall = callAjax("loadContacts", "", "post");
		oCall.success(function(oData) {
			if (oData.errorType == '')
			{
				clearErrors();

				$(el("contactsPopup")).remove();
				$(el("mainContainer")).append(oData.html);
				$(el("contactsPopup")).modal();

				centerPopups();
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	$(el('mainContainer')).on('click','#contactsPopup.enabled .listItem', function(e)
	{
		e.preventDefault();

		loginFromId($(this));
		return false;
	});

	$(el('mainContainer')).on('click','#contactsPopup .loaderWrapper', function()
	{
		return false;
	});

	$(el('mainContainer')).on('change','.priceRangeSwitch input', function()
	{
		var sPriceRange = ($(this).is(":checked")) ? "retail":"wholesale";
		switchPriceRangePreference($(this),sPriceRange)

		return false;
	});

	$(el('mainContainer')).on('click','.priceRangeLabel', function()
	{
		if (!editMode) {
			$('#priceRangeCheckbox').click();
		}
		return false;
	});

	$(el('mainContainer')).on('click','.priceRangeSwitchBtn', function()
	{
		switchPriceRangePreference($(this), $(this).data('pricerange'));
		return false;
	});

	$(el('mainContainer')).on('change','label.switch input', function()
	{
		var oSwitch    = $(this).parents('label.switch');
		var oLeftText  = oSwitch.find('.slider-text.left');
		var oRightText = oSwitch.find('.slider-text.right');
		var sOn        = oSwitch.data('on');
		var sOff       = oSwitch.data('off');

		if ($(this).is(':checked'))
		{
			oLeftText.text(sOn);
			oRightText.text("");
		}
		else
		{
			oLeftText.text("");
			oRightText.text(sOff);
		}

		return false;
	});

	$(el('mainContainer')).on('click','.btnEditSelectedWishlist', function()
	{
		showSelectedWishlistPopup($(this));
		return false;
	});

	$(el('mainContainer')).on('click','.btnRememberWishlist', function()
	{
		rememberWishlist($(this));
		return false;
	});

	window.onpopstate = function (e) {
		if(e.state == "addedProductToBasket")
		{
			window.history.replaceState(null, null, "");
			history.go(-1);
			location.reload();
		}
	};

	//External Authorization
	if ($('#btnExternalAuthorizationGlobal').length > 0 || $('.btnExternalAuthorizationGlobal') .length > 0) {
		$(el("mainContainer")).on("click", "#btnExternalAuthorizationGlobal,.btnExternalAuthorizationGlobal",function()
		{
			if(typeof $(this).data("auth-url") !== "undefined")
			{
				var sAuthUrl = $(this).data("auth-url");

				if($("#edtEmailQuickCheckout").length > 0 && $("#edtEmailQuickCheckout").val() !== "")
				{
					var separator = sAuthUrl.indexOf("?") !== -1 ? "&" : "?";
					sAuthUrl += separator + "login_hint=" + encodeURIComponent($("#edtEmailQuickCheckout").val());
				}

				window.location.href = sAuthUrl;
			}

			return false;
		});

		initExternalAuthorization();
	}

	$(el('mainContainer')).on('click','#allowNotCountsTowardsTotal', function()
	{
		if($(this).attr("action") === "addToWishlistList")
		{
			addToWishlistList($(".addProductWishlistModal .selectBtn"), false)
		}
		else if($(this).attr("action") === "addToWishlistPopup")
		{
			var sProductId = $(this).attr('productId');
			var oThumb = $('.thumb[data-product="' + sProductId + '"]');
			var oEl = oThumb.find('.btnAddWishlist');
			addToWishlistPopup(oEl, sProductId, false);
		}
		return false;
	});
});

var selectedImageIndex = 1 ; //auxilliar variable for the move up and move down functions
function moveSlider(imageIndex, colorID){
	selectedImageIndex = imageIndex;
	try{
		// elements
		var oVerticalSlider    		= document.getElementById(`verticalSlider_${colorID}`);
		var activeImageSlider 		= document.getElementById(`activeImageSlider_${colorID}`);

		if(oVerticalSlider.children.length > 1){

			// base variables
			var verticalSliderOffset    = $(`#verticalSlider_${colorID}`).offset().top;  // offset of the main slider
			var activeImageSlider       = $(`#activeImageSlider_${colorID}`).offset().top;  // offset of the main slider
			var offsetDiference         = $(`#verticalImage_${colorID}_2`).offset().top - $(`#verticalImage_${colorID}_1`).offset().top;  //diference of offset between images inside the slider
			var windowWidth				= $(window).width();
			var centrilizedImage        = windowWidth > 1400 ? 4 : 3; // marker to where to start moving the slider according to the amout of images framed in the slider
			// slider images loop
			Array.from(oVerticalSlider.children).forEach((item, imageIndex) => {

				//base variables
				imageIndex++; // image id
				var verticalSliderImage = $(`#verticalImage_${colorID}_${imageIndex}`);
				var activeSliderImage   =$(`#activeImageSlider_${colorID}_${imageIndex}`);


				//calculate each image position
				var originalPosition = verticalSliderOffset + (imageIndex - 1) * offsetDiference;
				var imageBaseOffset = (offsetDiference * imageIndex) + verticalSliderOffset;
				var position = 	 selectedImageIndex <= centrilizedImage ? originalPosition : imageBaseOffset - ((selectedImageIndex - 3) * offsetDiference);//use index to centrilize image 3 so when clicling the images 1 and 2 to prevent them for being centrilized with a empty space above

				// motion
				verticalSliderImage.offset({top: position});
				activeSliderImage.offset({top: activeImageSlider});
				// style selected images
				if(imageIndex == selectedImageIndex){
					verticalSliderImage.addClass("selected")
					activeSliderImage.css('visibility', 'visible');
				}else{
					verticalSliderImage.removeClass("selected");
					activeSliderImage.css('visibility', 'hidden');
				}
			});
		}
	} catch(err){
		alert(err)
	}
 }